var _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataExtractionBro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.72 437.25 131.79 437.01 212.86 436.92 375 436.75 537.14 436.92 618.21 437.01 699.28 437.25 618.21 437.5 537.14 437.59 375 437.75 212.86 437.58 131.79 437.5 50.72 437.25",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.19,
    y: 308.36,
    width: 105.85,
    height: 128.9,
    transform: "translate(224.24 745.61) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.03,
    y: 312.63,
    width: 94.29,
    height: 26.4,
    transform: "translate(192.36 651.66) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.33,
    y: 312.63,
    width: 24.96,
    height: 26.4,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 316.99,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 636.21) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 320.85,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 643.93) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 324.72,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 651.66) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 328.58,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 659.39) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 332.44,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 667.11) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.82,
    cy: 319.2,
    r: 2.21,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,319.2A2.21,2.21,0,1,0,76.53,317,2.21,2.21,0,0,0,74.32,319.2Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,319.2A2.21,2.21,0,1,0,69.25,317,2.2,2.2,0,0,0,67,319.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,319.2A2.21,2.21,0,1,0,62,317,2.21,2.21,0,0,0,59.75,319.2Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,319.2A2.21,2.21,0,1,0,54.67,317,2.21,2.21,0,0,0,52.46,319.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,325.83a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,325.83Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,325.83a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,325.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,325.83a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,325.83Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,325.83A2.21,2.21,0,1,0,62,323.62,2.21,2.21,0,0,0,59.75,325.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,325.83a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,325.83Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,332.46a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,332.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,332.46a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,332.46Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,332.46a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,332.46Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,332.46A2.21,2.21,0,1,0,62,330.25,2.21,2.21,0,0,0,59.75,332.46Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,332.46a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,332.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 316.99,
    width: 1.27,
    height: 17.68,
    transform: "translate(179.16 651.66) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.03,
    y: 342.38,
    width: 94.29,
    height: 26.4,
    transform: "translate(192.36 711.16) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.33,
    y: 342.38,
    width: 24.96,
    height: 26.4,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 346.74,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 695.7) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 350.6,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 703.43) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 354.46,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 711.16) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 358.33,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 718.88) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 362.19,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 726.61) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.82,
    cy: 348.95,
    r: 2.21,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,349a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,349Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,349a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,349Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,349A2.21,2.21,0,1,0,62,346.74,2.21,2.21,0,0,0,59.75,349Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,349a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,349Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,355.58a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,355.58Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,355.58a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,355.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,355.58a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,355.58Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,355.58A2.21,2.21,0,1,0,62,353.37,2.21,2.21,0,0,0,59.75,355.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,355.58a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,355.58Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,362.21A2.21,2.21,0,1,0,83.82,360,2.21,2.21,0,0,0,81.61,362.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,362.21A2.21,2.21,0,1,0,76.53,360,2.21,2.21,0,0,0,74.32,362.21Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,362.21A2.21,2.21,0,1,0,69.25,360,2.2,2.2,0,0,0,67,362.21Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,362.21A2.21,2.21,0,1,0,62,360,2.21,2.21,0,0,0,59.75,362.21Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,362.21A2.21,2.21,0,1,0,54.67,360,2.21,2.21,0,0,0,52.46,362.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 346.74,
    width: 1.27,
    height: 17.68,
    transform: "translate(179.16 711.16) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.03,
    y: 372.13,
    width: 94.29,
    height: 26.4,
    transform: "translate(192.36 770.65) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.33,
    y: 372.13,
    width: 24.96,
    height: 26.4,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 376.49,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 755.2) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 380.35,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 762.93) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 384.21,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 770.65) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 388.07,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 778.38) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 391.94,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 786.1) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,378.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,378.7Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,378.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,378.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,378.7a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,378.7Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,378.7A2.21,2.21,0,1,0,62,376.49,2.21,2.21,0,0,0,59.75,378.7Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,378.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,378.7Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,385.33a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,385.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,385.33a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,385.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,385.33a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,385.33Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,385.33A2.21,2.21,0,1,0,62,383.12,2.21,2.21,0,0,0,59.75,385.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,385.33a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,385.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,392a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,392Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,392a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,392Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,392a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,392Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,392A2.21,2.21,0,1,0,62,389.75,2.21,2.21,0,0,0,59.75,392Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,392a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,392Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 376.49,
    width: 1.27,
    height: 17.68,
    transform: "translate(179.16 770.65) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.03,
    y: 401.87,
    width: 94.29,
    height: 26.4,
    transform: "translate(192.36 830.15) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.33,
    y: 401.87,
    width: 24.96,
    height: 26.4,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 406.23,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 814.7) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 410.1,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 822.42) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 413.96,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 830.15) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 417.82,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 837.87) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 421.68,
    width: 45.05,
    height: 2.23,
    transform: "translate(231.98 845.6) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.82,
    cy: 408.44,
    r: 2.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,408.44a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,408.44Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,408.44a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,408.44Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,408.44A2.21,2.21,0,1,0,62,406.23,2.21,2.21,0,0,0,59.75,408.44Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,408.44a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,408.44Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.82,
    cy: 415.07,
    r: 2.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,415.07a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,415.07Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,415.07a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,415.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,415.07A2.21,2.21,0,1,0,62,412.86,2.21,2.21,0,0,0,59.75,415.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,415.07a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,415.07Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,421.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,421.7Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,421.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,421.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,421.7a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,421.7Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,421.7A2.21,2.21,0,1,0,62,419.49,2.21,2.21,0,0,0,59.75,421.7Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,421.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,421.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 406.23,
    width: 1.27,
    height: 17.68,
    transform: "translate(179.16 830.15) rotate(180)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.11,
    y: 417.23,
    width: 549.78,
    height: 20.02,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.92,
    y: 125.47,
    width: 436.16,
    height: 291.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.09,
    y: 129.03,
    width: 429.83,
    height: 284.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.12,
    y: 147.32,
    width: 391.76,
    height: 248.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.12,
    y: 147.32,
    width: 391.76,
    height: 9.54,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.11,152.1a1.81,1.81,0,1,1-1.81-1.81A1.81,1.81,0,0,1,188.11,152.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.48,152.1a1.81,1.81,0,1,1-1.81-1.81A1.81,1.81,0,0,1,195.48,152.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.86,152.1a1.81,1.81,0,1,1-1.81-1.81A1.81,1.81,0,0,1,202.86,152.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.93 257.37 233.8 247.61 233.76 237.84 233.68 218.32 233.76 198.79 233.8 189.03 233.93 179.26 234.05 189.03 234.09 198.79 234.18 218.32 234.09 237.84 234.05 247.61 233.93 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.09 257.37 260.97 247.61 260.93 237.84 260.84 218.32 260.92 198.79 260.97 189.03 261.09 179.26 261.21 189.03 261.26 198.79 261.34 218.32 261.26 237.84 261.21 247.61 261.09 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.26 257.37 288.14 247.61 288.09 237.84 288.01 218.32 288.09 198.79 288.13 189.03 288.26 179.26 288.38 189.03 288.43 198.79 288.51 218.32 288.43 237.84 288.38 247.61 288.26 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.42 257.37 315.3 247.61 315.26 237.84 315.17 218.32 315.26 198.79 315.3 189.03 315.42 179.26 315.55 189.03 315.59 198.79 315.68 218.32 315.59 237.84 315.55 247.61 315.42 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.59 257.37 342.47 247.61 342.42 237.84 342.34 218.32 342.42 198.79 342.47 189.03 342.59 179.26 342.71 189.03 342.76 198.79 342.84 218.32 342.76 237.84 342.71 247.61 342.59 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.76 257.37 369.63 247.61 369.59 237.84 369.5 218.32 369.59 198.79 369.63 189.03 369.76 179.26 369.88 189.03 369.92 198.79 370.01 218.32 369.92 237.84 369.88 247.61 369.76 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 257.37 396.8 247.61 396.76 237.84 396.67 218.32 396.75 198.79 396.8 189.03 396.92 179.26 397.05 189.03 397.09 198.79 397.17 218.32 397.09 237.84 397.05 247.61 396.92 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.09 257.37 423.97 247.61 423.92 237.84 423.84 218.32 423.92 198.79 423.97 189.03 424.09 179.26 424.21 189.03 424.26 198.79 424.34 218.32 424.26 237.84 424.21 247.61 424.09 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.25 257.37 451.13 247.61 451.09 237.84 451 218.32 451.09 198.79 451.13 189.03 451.25 179.26 451.38 189.03 451.42 198.79 451.51 218.32 451.42 237.84 451.38 247.61 451.25 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.42 257.37 478.3 247.61 478.25 237.84 478.17 218.32 478.25 198.79 478.3 189.03 478.42 179.26 478.55 189.03 478.59 198.79 478.67 218.32 478.59 237.84 478.54 247.61 478.42 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "505.59 257.37 505.46 247.61 505.42 237.84 505.34 218.32 505.42 198.79 505.46 189.03 505.59 179.26 505.71 189.03 505.75 198.79 505.84 218.32 505.75 237.84 505.71 247.61 505.59 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "532.75 257.37 532.63 247.61 532.59 237.84 532.5 218.32 532.59 198.79 532.63 189.03 532.75 179.26 532.88 189.03 532.92 198.79 533 218.32 532.92 237.84 532.88 247.61 532.75 257.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 179.26 291.51 179.09 376.25 179.01 461 179.09 545.74 179.26 461 179.43 376.25 179.51 291.51 179.43 206.76 179.26",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 198.19 291.51 198.02 376.25 197.93 461 198.02 545.74 198.19 461 198.35 376.25 198.44 291.51 198.35 206.76 198.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 217.11 291.51 216.94 376.25 216.86 461 216.94 545.74 217.11 461 217.28 376.25 217.36 291.51 217.28 206.76 217.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 236.03 291.51 235.86 376.25 235.78 461 235.86 545.74 236.03 461 236.2 376.25 236.28 291.51 236.2 206.76 236.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,217.11l27.11-9.69h0L261.08,206h.06l.06,0,27.19,10.8-.07,0,27.18,4.83h-.11l27.16-2.4-.18.05c9.05-4.85,18.08-9.73,27.16-14.53l.09-.05h.1l27.17-2.06H397l27.15,5.64H424l27.19-10.35.07,0h.07l27.16,2.89h-.09l27.21-6.65h0l10.12.06-10.12.07h0l-27.12,7h-.08l-27.18-2.75.14,0-27.14,10.47-.1,0-.1,0-27.18-5.52H397l-27.17,2.17.19-.05c-9,4.87-18.11,9.67-27.17,14.49l-.09,0h-.09l-27.17,2.28h-.11l-27.15-4.94h-.07L261,206.51l.12,0-27.18,1.24h0Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,207.59a2.27,2.27,0,1,1-2.26-2.26A2.27,2.27,0,0,1,236.19,207.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,210.36a2.77,2.77,0,1,1,2.76-2.77A2.77,2.77,0,0,1,233.93,210.36Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,233.93,205.83Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.36,206.31a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,263.36,206.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.09,209.08a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,261.09,209.08Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,261.09,204.55Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.69,222a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,317.69,222Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.42,224.76a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,315.42,224.76Zm0-4.53a1.76,1.76,0,1,0,1.77,1.76A1.76,1.76,0,0,0,315.42,220.23Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.59,
    cy: 205.33,
    r: 2.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59,208.09a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,369.59,208.09Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.76,1.76,0,0,0,369.59,203.56Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.35,208.82a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,426.35,208.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.09,211.59a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,424.09,211.59Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,424.09,207.06Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,219.73a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,344.86,219.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.59,222.5a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,342.59,222.5Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,342.59,218Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.19,203.06a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,399.19,203.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.92,205.83a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,396.92,205.83Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,396.92,201.3Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.69,200.8a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,480.69,200.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.42,203.56a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,478.42,203.56Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.76,1.76,0,0,0,478.42,199Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.85,194.19a2.27,2.27,0,1,1-2.26-2.26A2.27,2.27,0,0,1,507.85,194.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.59,197a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,505.59,197Zm0-4.53a1.77,1.77,0,1,0,1.76,1.76A1.76,1.76,0,0,0,505.59,192.43Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.52,198.06a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,453.52,198.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.25,200.82a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,451.25,200.82Zm0-4.53a1.77,1.77,0,1,0,1.77,1.77A1.76,1.76,0,0,0,451.25,196.29Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.52,217.11a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,290.52,217.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26,219.88a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,288.26,219.88Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,288.26,215.35Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,236.14l27.14-3.52-.07,0,27.1-18.71,0,0h0l27.15-10.19.11,0,.12,0,27.18,9.1h.05l0,0,27.19,16.87-.41,0c9.05-3.6,18.09-7.22,27.16-10.77l.2-.07.19.09,27.14,13.47-.51.11,27.21-32,.17-.2.24.09,27.14,10.23-.14,0,27.17-3.3h0l27.16,1.4h0l10.14-3.43-10.1,3.55h0l-27.17-1.06h0l-27.16,3.44h-.07l-.07,0L424,201.14l.41-.11-27.12,32-.22.25-.3-.14-27.19-13.37h.39c-9,3.62-18.11,7.16-27.17,10.73l-.22.08-.19-.12-27.14-17,.09,0-27.15-9.21h.23l-27.19,10.07.06,0L234,232.94l0,0h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,232.79a2.27,2.27,0,1,1-2.26-2.26A2.26,2.26,0,0,1,236.19,232.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,235.56a2.77,2.77,0,1,1,2.76-2.76A2.77,2.77,0,0,1,233.93,235.56Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.77,1.77,0,0,0,233.93,231Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.36,214.18a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,263.36,214.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.09,216.94a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,261.09,216.94Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.76,1.76,0,0,0,261.09,212.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.69,213.37a2.27,2.27,0,1,1-2.27-2.27A2.26,2.26,0,0,1,317.69,213.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.42,216.14a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,315.42,216.14Zm0-4.53a1.76,1.76,0,1,0,1.77,1.76A1.76,1.76,0,0,0,315.42,211.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.85,219.73a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,371.85,219.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59,222.5a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,369.59,222.5Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,369.59,218Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.35,200.8a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,426.35,200.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.09,203.56a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,424.09,203.56Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.76,1.76,0,0,0,424.09,199Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,229.78a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,344.86,229.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.59,232.55a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,342.59,232.55Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,342.59,228Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.19,232.38a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,399.19,232.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.92,235.15a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,396.92,235.15Zm0-4.53a1.77,1.77,0,1,0,1.76,1.76A1.76,1.76,0,0,0,396.92,230.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.69,207.6a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,480.69,207.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.42,210.37a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,478.42,210.37Zm0-4.53a1.77,1.77,0,1,0,1.76,1.76A1.76,1.76,0,0,0,478.42,205.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.85,208.82a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,507.85,208.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.59,211.59a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,505.59,211.59Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,505.59,207.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.52,211.08a2.27,2.27,0,1,1-2.26-2.26A2.27,2.27,0,0,1,453.52,211.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.25,213.85a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,451.25,213.85Zm0-4.53a1.77,1.77,0,1,0,1.77,1.76A1.76,1.76,0,0,0,451.25,209.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.52,204a2.27,2.27,0,1,1-2.26-2.26A2.27,2.27,0,0,1,290.52,204Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26,206.81A2.77,2.77,0,1,1,291,204,2.77,2.77,0,0,1,288.26,206.81Zm0-4.53A1.76,1.76,0,1,0,290,204,1.76,1.76,0,0,0,288.26,202.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,175.24l.19,38.94.1,38.93-.29-.3,84.75-.13,42.37-.07,42.37.06,84.75.14c28.25,0,56.5.17,84.74.3-28.24.13-56.49.29-84.74.3l-84.75.14-42.37.06-42.37-.07-84.75-.14h-.3v-.29l.11-38.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,179.26a5.85,5.85,0,0,1,2.5-.5,5.73,5.73,0,0,1,2.5.5,6.5,6.5,0,0,1-5,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,198.18a6.5,6.5,0,0,1,5,0,6.38,6.38,0,0,1-5,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,217.11a6.38,6.38,0,0,1,5,0,5.73,5.73,0,0,1-2.5.5A5.85,5.85,0,0,1,204.26,217.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,236a6.5,6.5,0,0,1,5,0,6.5,6.5,0,0,1-5,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.24,261.14a.06.06,0,0,1,.09,0,.57.57,0,0,0,1.12-.17v-1.33a.07.07,0,1,1,.14,0V261a.72.72,0,0,1-1.4.22A.07.07,0,0,1,227.24,261.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.25,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1-.05-.09l.74-2a.08.08,0,0,1,.14,0l.74,2a.07.07,0,0,1,0,.09h0a.09.09,0,0,1-.07-.05Zm-.92-.15h.86l-.43-1.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.19,259.92v1.73a.07.07,0,1,1-.14,0v-1.94a.08.08,0,0,1,0-.08s.09,0,.11,0l1.28,1.78V259.7a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.95a.08.08,0,0,1-.08.08.05.05,0,0,1-.05,0h0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.22,259.68a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.19a.71.71,0,1,0,1.41,0v-1.19a.08.08,0,0,1,.08-.07.07.07,0,0,1,.07.07v1.19a.86.86,0,1,1-1.71,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.68,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1,0-.09l.74-2a.08.08,0,0,1,.14,0l.74,2a.07.07,0,0,1,0,.09h0a.08.08,0,0,1-.07-.05Zm-.91-.15h.86l-.43-1.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.53,261.25a.38.38,0,0,0-.17-.32.78.78,0,0,0-.25-.11h-.53v.84a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.07.07,0,0,1,.07-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48,1.1,1.1,0,0,0,0,.24.07.07,0,0,0,0,.05.08.08,0,0,1,.08,0,.08.08,0,0,1,0,.1h-.05a.16.16,0,0,1-.13-.09A.7.7,0,0,1,238.53,261.25Zm-.42-1.5h-.53v.92h.54a.46.46,0,0,0,.44-.46A.46.46,0,0,0,238.11,259.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.87,260.71l-.71-1s0-.09,0-.11.09,0,.11,0l.66.91.67-.91a.07.07,0,0,1,.1,0,.08.08,0,0,1,0,.11l-.7,1v.95a.08.08,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.9,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.91a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.72,259.68a.08.08,0,0,1,.08-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.1.1,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,259.68a.07.07,0,0,1,.07-.07h.47a.53.53,0,0,1,.53.53.54.54,0,0,1-.2.41.61.61,0,0,1-.2,1.18h-.6a.08.08,0,0,1-.07-.08Zm.54.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.4v.76Zm.13,1.07a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.36,261.25a.36.36,0,0,0-.17-.32.67.67,0,0,0-.24-.11h-.53v.84a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,.6.6.62.62,0,0,1-.34.55h0a.57.57,0,0,1,.28.48.62.62,0,0,0,0,.24s0,.05,0,.05a.09.09,0,0,1,.08,0,.09.09,0,0,1,0,.1h0a.19.19,0,0,1-.14-.09A.84.84,0,0,1,260.36,261.25Zm-.42-1.5h-.52v.92H260a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,259.68a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,1,0,1.42,0v-1.19a.07.07,0,0,1,.14,0v1.19a.86.86,0,1,1-1.71,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.49,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1-.05-.09l.74-2a.07.07,0,0,1,.07,0s.07,0,.07,0l.74,2a.06.06,0,0,1,0,.09h0a.1.1,0,0,1-.07-.05Zm-.92-.15h.86l-.43-1.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,261.25a.38.38,0,0,0-.17-.32.7.7,0,0,0-.25-.11h-.53v.84a.07.07,0,1,1-.14,0v-2a.07.07,0,0,1,.06-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48,1.1,1.1,0,0,0,0,.24l0,.05a.11.11,0,0,1,.09,0,.09.09,0,0,1-.05.1h0a.17.17,0,0,1-.14-.09A.7.7,0,0,1,266.33,261.25Zm-.42-1.5h-.53v.92h.54a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.67,260.71l-.71-1a.09.09,0,0,1,0-.11.07.07,0,0,1,.1,0l.66.91.67-.91a.07.07,0,0,1,.1,0,.09.09,0,0,1,0,.11l-.71,1v.95a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87,259.91l-.67.94-.06,0h0a.06.06,0,0,1-.06,0l-.68-.94v1.74a.09.09,0,0,1-.07.08.08.08,0,0,1-.08-.08v-2a.09.09,0,0,1,0-.06h0a.07.07,0,0,1,.1,0l.75,1,.75-1s.07,0,.11,0l0,0s0,0,0,0v2a.08.08,0,0,1-.07.08.08.08,0,0,1-.08-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1,0-.09l.74-2a.08.08,0,0,1,.14,0l.74,2a.08.08,0,0,1,0,.09h0a.08.08,0,0,1-.07-.05Zm-.91-.15h.86l-.43-1.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.6,261.25a.38.38,0,0,0-.17-.32.78.78,0,0,0-.25-.11h-.53v.84a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.07.07,0,0,1,.07-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.54.54,0,0,1,.28.48.93.93,0,0,0,0,.24.07.07,0,0,0,0,.05.08.08,0,0,1,.08,0,.1.1,0,0,1,0,.1h0a.16.16,0,0,1-.13-.09A.7.7,0,0,1,288.6,261.25Zm-.42-1.5h-.53v.92h.54a.46.46,0,0,0,.44-.46A.46.46,0,0,0,288.18,259.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.44,259.58a1.17,1.17,0,0,1,.69.23.08.08,0,0,1,0,.11.08.08,0,0,1-.1,0,1,1,0,0,0-.6-.21.93.93,0,1,0,0,1.86.92.92,0,0,0,.59-.21.08.08,0,0,1,.1.13,1.17,1.17,0,0,1-.69.23,1.08,1.08,0,1,1,0-2.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,260.74h-1.09v.91a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.08.08,0,0,1,.08-.07.07.07,0,0,1,.07.07v.91H293v-.91a.08.08,0,0,1,.07-.07.07.07,0,0,1,.08.07v2a.08.08,0,0,1-.08.08.09.09,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1-.05-.09l.74-2a.07.07,0,0,1,.07,0s.07,0,.07,0l.74,2a.06.06,0,0,1,0,.09h0a.1.1,0,0,1-.07-.05Zm-.91-.15h.85l-.42-1.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.58,259.68a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,0,1.2h-.52v.83a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Zm.67,1a.46.46,0,0,0,0-.92h-.52v.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.39,261.25a.36.36,0,0,0-.17-.32.67.67,0,0,0-.24-.11h-.53v.84a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.06-.07H316a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48.62.62,0,0,0,0,.24s0,.05,0,.05a.09.09,0,0,1,.08,0,.09.09,0,0,1-.05.1h0a.17.17,0,0,1-.14-.09A.84.84,0,0,1,316.39,261.25Zm-.42-1.5h-.52v.92H316a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.25,259.68a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v2a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.23,261.73h0a.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.9h1a.07.07,0,0,1,.08.07.08.08,0,0,1-.08.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.59,259.91l-.68.94-.06,0h0l-.06,0-.68-.94v1.74a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2s0,0,0-.06h0a.07.07,0,0,1,.1,0l.76,1,.75-1a.07.07,0,0,1,.1,0l0,0a.06.06,0,0,1,0,0v2a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.47,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1-.05-.09l.74-2a.07.07,0,0,1,.07,0s.07,0,.07,0l.74,2a.06.06,0,0,1,0,.09h0a.1.1,0,0,1-.07-.05Zm-.91-.15h.85l-.43-1.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61,260.71l-.71-1a.09.09,0,0,1,0-.11.07.07,0,0,1,.1,0l.66.91.67-.91a.07.07,0,0,1,.1,0s0,.07,0,.11l-.71,1v.95a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.88,261.14a.06.06,0,0,1,.09,0,.57.57,0,0,0,.54.4.58.58,0,0,0,.58-.57v-1.33a.07.07,0,1,1,.14,0V261a.72.72,0,0,1-1.4.22A.07.07,0,0,1,365.88,261.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.8,259.68a.08.08,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,0,0,1.42,0v-1.19a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.19a.86.86,0,0,1-1.72,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.37,259.92v1.73a.08.08,0,1,1-.15,0v-1.94a.07.07,0,0,1,0-.08.07.07,0,0,1,.1,0l1.29,1.78V259.7a.07.07,0,0,1,.14,0v1.95a.08.08,0,0,1-.07.08.07.07,0,0,1-.06,0h0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.35,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.09.09,0,0,1-.06-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.49,261.14a.06.06,0,0,1,.09,0,.57.57,0,0,0,1.11-.17v-1.33a.08.08,0,0,1,.08-.07.07.07,0,0,1,.07.07V261a.72.72,0,0,1-1.4.22A.07.07,0,0,1,393.49,261.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.41,259.68a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,1,0,1.42,0v-1.19a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.19a.86.86,0,1,1-1.72,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,261.73h0a.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.9h1a.08.08,0,0,1,.08.07.09.09,0,0,1-.08.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.62,260.71l-.71-1a.08.08,0,0,1,0-.11.07.07,0,0,1,.1,0l.67.91.66-.91s.07,0,.11,0a.08.08,0,0,1,0,.11l-.71,1v.95a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0s-.06-.06,0-.09l.73-2a.09.09,0,0,1,.08,0,.07.07,0,0,1,.07,0l.74,2a.08.08,0,0,1,0,.09h0a.08.08,0,0,1-.07-.05Zm-.91-.15h.86l-.43-1.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.69,259.68a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,1,0,1.42,0v-1.19a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.19a.86.86,0,1,1-1.72,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14,260.77a.08.08,0,0,1-.08-.07.09.09,0,0,1,.08-.08h.66a.08.08,0,0,1,.07.08v.73h0a.05.05,0,0,1,0,.05,1.08,1.08,0,0,1-.68.24,1.08,1.08,0,1,1,0-2.15,1.08,1.08,0,0,1,.68.24.07.07,0,0,1,0,.1.08.08,0,0,1-.1,0,.94.94,0,1,0-.59,1.65,1,1,0,0,0,.56-.18v-.63Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.61,259.68a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,1,0,1.42,0v-1.19a.07.07,0,1,1,.14,0v1.19a.86.86,0,1,1-1.71,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,261.33a.06.06,0,0,1,.09,0,1.11,1.11,0,0,0,.7.27.77.77,0,0,0,.47-.14.39.39,0,0,0,.18-.31.35.35,0,0,0-.17-.29,1.23,1.23,0,0,0-.49-.17h0a1.54,1.54,0,0,1-.5-.18.46.46,0,0,1-.22-.37.51.51,0,0,1,.22-.4.85.85,0,0,1,.51-.15,1.19,1.19,0,0,1,.66.24.08.08,0,0,1,0,.1.06.06,0,0,1-.09,0,1.06,1.06,0,0,0-.59-.22.73.73,0,0,0-.43.13.38.38,0,0,0-.16.29.3.3,0,0,0,.15.25,1.08,1.08,0,0,0,.46.16h0a1.38,1.38,0,0,1,.54.2.47.47,0,0,1,.23.4.52.52,0,0,1-.23.42.92.92,0,0,1-.55.17,1.32,1.32,0,0,1-.78-.31A.06.06,0,0,1,427,261.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.59,259.75H429a.07.07,0,1,1,0-.14h1.42a.07.07,0,0,1,0,.14h-.64v1.9a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.77,261.33a.08.08,0,0,1,.1,0,1.08,1.08,0,0,0,.69.27.77.77,0,0,0,.47-.14.37.37,0,0,0,.18-.31.35.35,0,0,0-.17-.29,1.23,1.23,0,0,0-.49-.17h0a1.54,1.54,0,0,1-.5-.18.46.46,0,0,1-.22-.37.51.51,0,0,1,.22-.4.89.89,0,0,1,.52-.15,1.18,1.18,0,0,1,.65.24.08.08,0,0,1,0,.1.06.06,0,0,1-.09,0,1.06,1.06,0,0,0-.58-.22.74.74,0,0,0-.44.13.38.38,0,0,0-.16.29.3.3,0,0,0,.15.25,1.08,1.08,0,0,0,.46.16h0a1.32,1.32,0,0,1,.54.2.48.48,0,0,1,.24.4.53.53,0,0,1-.24.42.92.92,0,0,1-.55.17,1.32,1.32,0,0,1-.78-.31A.06.06,0,0,1,442.77,261.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.88,259.68a.08.08,0,0,1,.08-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07H445v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08H445a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.68,259.68a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,0,1.2h-.53v.83a.07.07,0,1,1-.14,0Zm.67,1a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,259.75h-.64a.07.07,0,1,1,0-.14h1.42a.07.07,0,0,1,0,.14h-.64v1.9a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.4,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.09.09,0,0,1-.06-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.82,259.91l-.68.94a.07.07,0,0,1-.06,0h0a.09.09,0,0,1-.07,0l-.67-.94v1.74a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.09.09,0,0,1,0-.06h0a.08.08,0,0,1,.11,0l.75,1,.75-1a.07.07,0,0,1,.1,0l0,0s0,0,0,0v2a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.74,259.68a.07.07,0,0,1,.07-.07h.47a.53.53,0,0,1,.53.53.54.54,0,0,1-.2.41.61.61,0,0,1-.19,1.18h-.61a.08.08,0,0,1-.07-.08Zm.54.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.39v.76Zm.14,1.07a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.53,259.68a.08.08,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.08.07.08.08,0,0,1-.08.08H456.6a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.44,261.25a.37.37,0,0,0-.18-.32.67.67,0,0,0-.24-.11h-.53v.84a.08.08,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,.61.6.63.63,0,0,1-.35.55h0a.54.54,0,0,1,.28.48.93.93,0,0,0,0,.24.07.07,0,0,0,0,.05.09.09,0,0,1,.08,0,.09.09,0,0,1-.05.1h0a.16.16,0,0,1-.13-.09A.7.7,0,0,1,459.44,261.25Zm-.43-1.5h-.52v.92H459a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.37,259.58a1.08,1.08,0,0,1,0,2.15,1.08,1.08,0,0,1,0-2.15Zm0,2a.9.9,0,0,0,.86-.93.87.87,0,1,0-1.74,0A.91.91,0,0,0,472.37,261.58Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.92,259.58a1.17,1.17,0,0,1,.69.23.08.08,0,0,1,0,.11.08.08,0,0,1-.1,0,1,1,0,0,0-.6-.21.93.93,0,1,0,0,1.86.92.92,0,0,0,.59-.21s.09,0,.11,0a.08.08,0,0,1,0,.11,1.17,1.17,0,0,1-.69.23,1.08,1.08,0,1,1,0-2.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.79,259.75h-.64a.07.07,0,0,1,0-.14h1.43a.07.07,0,0,1,0,.14h-.64v1.9a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,259.58a1.08,1.08,0,0,1,0,2.15,1.08,1.08,0,0,1,0-2.15Zm0,2a.9.9,0,0,0,.86-.93.87.87,0,1,0-.86.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.5,259.68a.07.07,0,0,1,.07-.07H481a.53.53,0,0,1,.53.53.54.54,0,0,1-.2.41.59.59,0,0,1,.41.57.6.6,0,0,1-.6.61h-.61a.08.08,0,0,1-.07-.08Zm.54.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.39v.76Zm.14,1.07a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.29,259.68a.08.08,0,0,1,.08-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.2,261.25a.38.38,0,0,0-.17-.32.78.78,0,0,0-.25-.11h-.53v.84a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.07.07,0,0,1,.07-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48,1.1,1.1,0,0,0,0,.24.07.07,0,0,0,0,.05.08.08,0,0,1,.08,0,.1.1,0,0,1,0,.1h-.05a.16.16,0,0,1-.13-.09A.7.7,0,0,1,485.2,261.25Zm-.42-1.5h-.53v.92h.54a.46.46,0,0,0,.44-.46A.46.46,0,0,0,484.78,259.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.72,259.92v1.73a.08.08,0,1,1-.15,0v-1.94a.07.07,0,0,1,0-.08.07.07,0,0,1,.1,0l1.29,1.78V259.7a.07.07,0,0,1,.14,0v1.95a.08.08,0,0,1-.07.08.07.07,0,0,1-.06,0h0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.67,259.58a1.08,1.08,0,1,1-1,1.07A1,1,0,0,1,500.67,259.58Zm0,2a.9.9,0,0,0,.86-.93.87.87,0,1,0-1.73,0A.9.9,0,0,0,500.67,261.58Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.89,261.68h0l-.82-1.95a.08.08,0,0,1,0-.1.09.09,0,0,1,.1,0l.75,1.81.76-1.81s.06-.05.1,0a.1.1,0,0,1,0,.1l-.83,1.94a.05.05,0,0,1,0,.06h-.06S502.89,261.7,502.89,261.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.36,259.68a.08.08,0,0,1,.08-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.79,259.91l-.68.94a.07.07,0,0,1-.06,0h0a.09.09,0,0,1-.07,0l-.68-.94v1.74a.07.07,0,1,1-.14,0v-2a.09.09,0,0,1,0-.06h0s.08,0,.1,0l.76,1,.75-1a.07.07,0,0,1,.1,0l0,0,0,0v2a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.71,259.68a.07.07,0,0,1,.07-.07h.47a.53.53,0,0,1,.53.53.54.54,0,0,1-.2.41.61.61,0,0,1-.2,1.18h-.6a.08.08,0,0,1-.07-.08Zm.54.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.39v.76Zm.13,1.07a.46.46,0,0,0,0-.92h-.52v.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.5,259.68a.08.08,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.08.07.08.08,0,0,1-.08.08h-1.09a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.41,261.25a.38.38,0,0,0-.17-.32.78.78,0,0,0-.25-.11h-.53v.84a.08.08,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,.61.6.63.63,0,0,1-.35.55h0a.54.54,0,0,1,.28.48.62.62,0,0,0,0,.24.07.07,0,0,0,0,.05.09.09,0,0,1,.08,0,.09.09,0,0,1-.05.1h0a.16.16,0,0,1-.13-.09A.7.7,0,0,1,513.41,261.25Zm-.43-1.5h-.52v.92H513a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.14,261.73h0a.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07h.4a1.06,1.06,0,1,1,0,2.12Zm.39-.15a.92.92,0,0,0,0-1.83h-.32v1.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.08,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.09.09,0,0,1,.07.08.08.08,0,0,1-.07.07h-.89v.84h1a.08.08,0,0,1,.08.07.09.09,0,0,1-.08.08h-1.09a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.88,259.58a1.11,1.11,0,0,1,.68.23.08.08,0,0,1,0,.11.09.09,0,0,1-.11,0,.93.93,0,1,0,0,1.44.07.07,0,0,1,.1,0,.07.07,0,0,1,0,.11,1.11,1.11,0,0,1-.68.23,1.08,1.08,0,1,1,0-2.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.2,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.08.07.08.08,0,0,1-.08.08h-1.09a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.63,259.91l-.68.94-.06,0h0a.07.07,0,0,1-.06,0l-.68-.94v1.74a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.09.09,0,0,1,0-.06h0a.07.07,0,0,1,.1,0l.76,1,.75-1a.07.07,0,0,1,.1,0l0,0a.06.06,0,0,1,0,0v2a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.54,259.68a.08.08,0,0,1,.08-.07h.47a.53.53,0,0,1,.53.53.55.55,0,0,1-.21.41.6.6,0,0,1,.42.57.61.61,0,0,1-.61.61h-.61a.08.08,0,0,1-.07-.08Zm.55.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.4v.76Zm.13,1.07a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.34,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.88a.09.09,0,0,1,.08.08.08.08,0,0,1-.08.07h-.88v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.09.09,0,0,1-.06-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.24,261.25a.36.36,0,0,0-.17-.32.75.75,0,0,0-.24-.11h-.53v.84a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.06-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48.62.62,0,0,0,0,.24s0,.05,0,.05a.09.09,0,0,1,.08,0,.09.09,0,0,1,0,.1h0a.17.17,0,0,1-.14-.09A.7.7,0,0,1,540.24,261.25Zm-.42-1.5h-.52v.92h.53a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.76,
    y: 274.48,
    width: 52.07,
    height: 24.54,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.76,
    y: 274.48,
    width: 24.96,
    height: 24.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.08,286.75a8.83,8.83,0,1,1-1.17-4.4A8.84,8.84,0,0,1,228.08,286.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.91,282.35l-7.67,4.4v-8.84A8.85,8.85,0,0,1,226.91,282.35Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.35,286.75a6.11,6.11,0,1,1-6.11-6.11A6.11,6.11,0,0,1,225.35,286.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.09,286l-.3.18h0a.07.07,0,0,1-.06,0,.08.08,0,0,1,0-.1l.41-.24a.08.08,0,0,1,.1,0,.13.13,0,0,1,0,.06v1.94a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.8,287.7a.08.08,0,0,1,.11-.11.56.56,0,0,0,.4.17.58.58,0,0,0,.4-.17.57.57,0,0,0,.16-.4.55.55,0,0,0-.16-.4.56.56,0,0,0-.8,0,.08.08,0,0,1-.11,0l0,0h0v0l.1-.85a.09.09,0,0,1,0-.05.06.06,0,0,1,.05,0h1a.07.07,0,0,1,.07.07.07.07,0,0,1-.07.08H218l-.08.63a.75.75,0,0,1,.36-.1.71.71,0,0,1,.51.21.7.7,0,0,1,.2.51.72.72,0,0,1-.2.51.77.77,0,0,1-.51.21A.71.71,0,0,1,217.8,287.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.58,286.31h0a.51.51,0,0,1,.47-.55.5.5,0,0,1,.46.54h0a.5.5,0,0,1-.47.54A.51.51,0,0,1,219.58,286.31Zm.78,0h0a.38.38,0,0,0-.32-.42c-.17,0-.3.19-.3.41h0c0,.23.14.41.31.41S220.36,286.54,220.36,286.31Zm-.49,1.51,1.47-2,.06,0s.07,0,.07.06,0,0,0,0l-1.48,2a.06.06,0,0,1-.06,0,.06.06,0,0,1-.06-.06S219.86,287.83,219.87,287.82Zm.94-.42h0a.5.5,0,0,1,.47-.54.49.49,0,0,1,.46.53h0a.47.47,0,1,1-.93,0Zm.78,0h0a.37.37,0,0,0-.32-.41c-.17,0-.3.18-.3.4h0c0,.24.14.41.31.41S221.59,287.62,221.59,287.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.88,
    y: 280.34,
    width: 9.94,
    height: 0.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.88,280.59a1.06,1.06,0,1,1-1.06-1.06A1.06,1.06,0,0,1,235.88,280.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.41,279.66a2.67,2.67,0,0,1,.17,1.64,3.53,3.53,0,0,1-.75,1.65,1.9,1.9,0,0,1-1.41.76,1.25,1.25,0,0,1-1.14-.76,2.69,2.69,0,0,1-.17-1.65,3.54,3.54,0,0,1,.75-1.64,1.91,1.91,0,0,1,1.41-.76A1.26,1.26,0,0,1,241.41,279.66Zm-.59,1.64a2,2,0,0,0-.12-1.22.64.64,0,0,0-.56-.42,1,1,0,0,0-.73.42,2.74,2.74,0,0,0-.54,1.22,2,2,0,0,0,.12,1.22.64.64,0,0,0,.56.43,1,1,0,0,0,.72-.43A2.65,2.65,0,0,0,240.82,281.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,279.26s0,0,0,0l-.71,4.05a.47.47,0,0,1-.45.38.31.31,0,0,1-.31-.38l.6-3.39-.3.17a.54.54,0,0,1-.21.05.3.3,0,0,1-.29-.18.43.43,0,0,1,.22-.52l.94-.5,0,0h0l0,0h.25l0,0,0,0,0,0,0,0s0,0,0,0l0,0h0a0,0,0,0,0,0,0v.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 285.81,
    width: 15.29,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 287.76,
    width: 12.78,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 289.7,
    width: 17.92,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 291.64,
    width: 7.65,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 293.59,
    width: 15.29,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.54,
    y: 274.48,
    width: 52.07,
    height: 24.54,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.54,
    y: 274.48,
    width: 24.96,
    height: 24.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,286.75a7.84,7.84,0,0,1-.1,1.29,8.75,8.75,0,1,1,.1-1.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,286.75a7.84,7.84,0,0,1-.1,1.29L283,286.75v-8.84a8.83,8.83,0,0,1,8.84,8.84Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.13,286.75a6.11,6.11,0,1,1-6.11-6.11A6.11,6.11,0,0,1,289.13,286.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.13,287.78l1-.9a.54.54,0,0,0-.36-.94.54.54,0,0,0-.37.14l-.1.09a.07.07,0,0,1-.1,0,.08.08,0,0,1,0-.11l.1-.09a.69.69,0,0,1,.47-.18.68.68,0,0,1,.51.22.71.71,0,0,1,.18.47.66.66,0,0,1-.23.51l-.84.77h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.19l-.06,0A.08.08,0,0,1,280.13,287.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,287.7a.08.08,0,0,1,0-.11.07.07,0,0,1,.1,0,.6.6,0,0,0,.4.17.56.56,0,0,0,.4-.17.54.54,0,0,0,.17-.4.55.55,0,0,0-.16-.4.58.58,0,0,0-.4-.17.6.6,0,0,0-.41.17.07.07,0,0,1-.1,0l0,0h0s0,0,0,0v0l.1-.85a.05.05,0,0,1,0-.05s0,0,.05,0h1a.07.07,0,0,1,.07.07.07.07,0,0,1-.07.08h-.93l-.07.63a.75.75,0,0,1,.36-.1.7.7,0,0,1,.5.21.67.67,0,0,1,.21.51.69.69,0,0,1-.21.51.75.75,0,0,1-.51.21A.69.69,0,0,1,282,287.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.75,286.31h0a.51.51,0,0,1,.47-.55.5.5,0,0,1,.46.54h0a.51.51,0,0,1-.47.54A.5.5,0,0,1,283.75,286.31Zm.77,0h0c0-.24-.14-.42-.31-.42s-.3.19-.3.41h0c0,.23.14.41.31.41S284.52,286.54,284.52,286.31Zm-.48,1.51,1.47-2a.07.07,0,0,1,.06,0,.06.06,0,0,1,.06.06.06.06,0,0,1,0,0l-1.47,2a.09.09,0,0,1-.06,0,.07.07,0,0,1-.07-.06A.05.05,0,0,1,284,287.82Zm.94-.42h0a.5.5,0,0,1,.47-.54.49.49,0,0,1,.46.53h0a.51.51,0,0,1-.47.54A.49.49,0,0,1,285,287.4Zm.77,0h0c0-.24-.14-.41-.31-.41s-.31.18-.31.4h0a.37.37,0,0,0,.32.41C285.62,287.8,285.75,287.62,285.75,287.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.66,
    y: 280.34,
    width: 9.94,
    height: 0.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.66,280.59a1.06,1.06,0,1,1-1.06-1.06A1.06,1.06,0,0,1,299.66,280.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,279.66a2.67,2.67,0,0,1,.17,1.64,3.53,3.53,0,0,1-.75,1.65,1.9,1.9,0,0,1-1.41.76,1.26,1.26,0,0,1-1.14-.76,2.69,2.69,0,0,1-.17-1.65,3.54,3.54,0,0,1,.75-1.64,1.91,1.91,0,0,1,1.41-.76A1.25,1.25,0,0,1,305.19,279.66Zm-.59,1.64a2,2,0,0,0-.12-1.22.64.64,0,0,0-.56-.42,1,1,0,0,0-.72.42,2.75,2.75,0,0,0-.55,1.22,2,2,0,0,0,.12,1.22.64.64,0,0,0,.56.43,1,1,0,0,0,.73-.43A2.64,2.64,0,0,0,304.6,281.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.72,283.34a.51.51,0,0,1-.45.38h-2.45a.32.32,0,0,1-.26-.13.41.41,0,0,1,.12-.54l2.36-1.83a1.11,1.11,0,0,0,.4-.66.78.78,0,0,0-.12-.6.76.76,0,0,0-.61-.29,1.09,1.09,0,0,0-.64.23l-.24.19a.38.38,0,0,1-.54,0,.42.42,0,0,1,.12-.54l.25-.19a2,2,0,0,1,1.18-.42,1.36,1.36,0,0,1,1.13.54,1.44,1.44,0,0,1,.23,1.11,2,2,0,0,1-.75,1.22L307.94,283h1.46A.32.32,0,0,1,309.72,283.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 285.81,
    width: 14.74,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 287.76,
    width: 8.47,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 289.7,
    width: 13.66,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 291.64,
    width: 17.92,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 293.59,
    width: 10.39,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.32,
    y: 274.48,
    width: 52.07,
    height: 24.54,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.32,
    y: 274.48,
    width: 24.96,
    height: 24.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.64,286.75a8.83,8.83,0,1,1-1.17-4.4A8.83,8.83,0,0,1,355.64,286.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.64,286.75A8.83,8.83,0,0,1,350,295l-3.17-8.25v-8.84a8.83,8.83,0,0,1,8.84,8.84Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.91,286.75a6.11,6.11,0,1,1-6.11-6.11A6.11,6.11,0,0,1,352.91,286.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,287.47h-1.2a.07.07,0,0,1,0-.11l1.23-1.52h0a.08.08,0,0,1,.1,0l0,0h0v1.46h.14a.07.07,0,1,1,0,.14h-.14v.36a.08.08,0,0,1-.08.08.08.08,0,0,1-.07-.08Zm0-.14v-1.25l-1,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.86,287.7a.08.08,0,0,1,.11-.11.56.56,0,0,0,.4.17.6.6,0,0,0,.4-.17.57.57,0,0,0,.16-.4.55.55,0,0,0-.16-.4.56.56,0,0,0-.8,0,.08.08,0,0,1-.11,0s0,0,0,0h0v0l.1-.85a.09.09,0,0,1,0-.05.06.06,0,0,1,0,0h1a.07.07,0,0,1,.07.07.07.07,0,0,1-.07.08h-.92l-.08.63a.75.75,0,0,1,.36-.1.73.73,0,0,1,.51.21.7.7,0,0,1,.2.51.72.72,0,0,1-.2.51.77.77,0,0,1-.51.21A.71.71,0,0,1,345.86,287.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64,286.31h0a.51.51,0,0,1,.47-.55.5.5,0,0,1,.46.54h0a.5.5,0,0,1-.47.54A.51.51,0,0,1,347.64,286.31Zm.78,0h0a.38.38,0,0,0-.32-.42c-.17,0-.3.19-.3.41h0c0,.23.14.41.31.41S348.42,286.54,348.42,286.31Zm-.49,1.51,1.47-2,.06,0s.07,0,.07.06a.08.08,0,0,1,0,0l-1.47,2a.06.06,0,0,1-.06,0,.06.06,0,0,1-.06-.06S347.92,287.83,347.93,287.82Zm.94-.42h0a.5.5,0,0,1,.47-.54.49.49,0,0,1,.46.53h0a.51.51,0,0,1-.47.54A.49.49,0,0,1,348.87,287.4Zm.78,0h0a.37.37,0,0,0-.32-.41c-.18,0-.3.18-.3.4h0c0,.24.14.41.31.41S349.65,287.62,349.65,287.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.44,
    y: 280.34,
    width: 9.94,
    height: 0.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.44,280.59a1.06,1.06,0,1,1-1.06-1.06A1.05,1.05,0,0,1,363.44,280.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,279.66a2.67,2.67,0,0,1,.17,1.64,3.53,3.53,0,0,1-.75,1.65,1.9,1.9,0,0,1-1.41.76,1.26,1.26,0,0,1-1.14-.76,2.69,2.69,0,0,1-.17-1.65,3.54,3.54,0,0,1,.75-1.64,1.91,1.91,0,0,1,1.41-.76A1.25,1.25,0,0,1,369,279.66Zm-.58,1.64a2.05,2.05,0,0,0-.13-1.22.64.64,0,0,0-.56-.42,1,1,0,0,0-.72.42,2.75,2.75,0,0,0-.55,1.22,2.12,2.12,0,0,0,.12,1.22.65.65,0,0,0,.56.43,1,1,0,0,0,.73-.43A2.76,2.76,0,0,0,368.39,281.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.38,280.79a1.5,1.5,0,0,1,.29,1.2,2.11,2.11,0,0,1-.72,1.21,2,2,0,0,1-1.29.5,1.42,1.42,0,0,1-1.12-.5.4.4,0,0,1,.1-.55.39.39,0,0,1,.55,0,.74.74,0,0,0,.6.27,1.13,1.13,0,0,0,.71-.27,1.19,1.19,0,0,0,.39-.66.79.79,0,0,0-.16-.65.78.78,0,0,0-.6-.28.29.29,0,0,1-.27-.12h0a.42.42,0,0,1,.09-.55l.83-.71h-1.11a.31.31,0,0,1-.32-.39.48.48,0,0,1,.46-.39h2a.31.31,0,0,1,.31.39.36.36,0,0,1-.07.18l-.09.1-1,.89A1.44,1.44,0,0,1,373.38,280.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 285.81,
    width: 14.08,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 287.76,
    width: 17.92,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 289.7,
    width: 10.76,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 291.64,
    width: 15.65,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 293.59,
    width: 6.32,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.1,
    y: 274.48,
    width: 52.07,
    height: 24.54,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.1,
    y: 274.48,
    width: 24.96,
    height: 24.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.42,286.75a8.83,8.83,0,1,1-1.17-4.4A8.78,8.78,0,0,1,419.42,286.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.42,286.75a8.84,8.84,0,0,1-14.57,6.72l5.73-6.72v-8.84a8.83,8.83,0,0,1,8.84,8.84Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.69,286.75a6.11,6.11,0,1,1-6.11-6.11A6.11,6.11,0,0,1,416.69,286.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.72,287.7a.08.08,0,1,1,.11-.11.58.58,0,0,0,.4.17.56.56,0,0,0,.4-.17.58.58,0,0,0,.17-.4.58.58,0,0,0-.57-.57.58.58,0,0,0-.4.17.07.07,0,0,1-.1,0l0,0h0v0l.11-.85a.05.05,0,0,1,0-.05s0,0,.05,0h1a.07.07,0,0,1,.08.07.07.07,0,0,1-.08.08H408l-.08.63a.78.78,0,0,1,.36-.1.72.72,0,0,1,.72.72.73.73,0,0,1-.21.51.77.77,0,0,1-.51.21A.73.73,0,0,1,407.72,287.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.55,287.7a.08.08,0,0,1,.11-.11.56.56,0,0,0,.4.17.58.58,0,0,0,.4-.17.57.57,0,0,0,.16-.4.55.55,0,0,0-.16-.4.56.56,0,0,0-.8,0,.08.08,0,0,1-.11,0s0,0,0,0h0v0l.11-.85a.05.05,0,0,1,0-.05,0,0,0,0,1,0,0h1a.08.08,0,0,1,.08.07.08.08,0,0,1-.08.08h-.92l-.08.63a.78.78,0,0,1,.36-.1.72.72,0,0,1,.72.72.73.73,0,0,1-.21.51.77.77,0,0,1-.51.21A.71.71,0,0,1,409.55,287.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.33,286.31h0a.48.48,0,1,1,.94,0h0a.47.47,0,1,1-.94,0Zm.78,0h0c0-.24-.14-.42-.31-.42s-.31.19-.31.41h0c0,.23.14.41.31.41S412.11,286.54,412.11,286.31Zm-.49,1.51,1.48-2a.05.05,0,0,1,0,0s.07,0,.07.06a.06.06,0,0,1,0,0l-1.48,2a.06.06,0,0,1-.06,0,.06.06,0,0,1-.06-.06S411.61,287.83,411.62,287.82Zm.94-.42h0a.5.5,0,0,1,.47-.54.49.49,0,0,1,.46.53h0a.47.47,0,1,1-.93,0Zm.78,0h0A.37.37,0,0,0,413,287c-.18,0-.31.18-.31.4h0c0,.24.14.41.31.41S413.34,287.62,413.34,287.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.23,
    y: 280.34,
    width: 9.94,
    height: 0.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.22,280.59a1.06,1.06,0,1,1-1.06-1.06A1.05,1.05,0,0,1,427.22,280.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.75,279.66a2.67,2.67,0,0,1,.17,1.64,3.53,3.53,0,0,1-.75,1.65,1.89,1.89,0,0,1-1.4.76,1.24,1.24,0,0,1-1.14-.76,2.69,2.69,0,0,1-.18-1.65,3.54,3.54,0,0,1,.75-1.64,1.91,1.91,0,0,1,1.41-.76A1.24,1.24,0,0,1,432.75,279.66Zm-.58,1.64a2.05,2.05,0,0,0-.13-1.22.64.64,0,0,0-.56-.42,1,1,0,0,0-.72.42,2.63,2.63,0,0,0-.54,1.22,2,2,0,0,0,.11,1.22.65.65,0,0,0,.57.43,1,1,0,0,0,.72-.43A2.76,2.76,0,0,0,432.17,281.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.9,282.44a.48.48,0,0,1-.45.38h-.07l-.09.52a.47.47,0,0,1-.44.38.32.32,0,0,1-.32-.38l.1-.52h-2.17a.27.27,0,0,1-.22-.09.37.37,0,0,1,0-.53l3.09-3.15h0l0,0,0,0,0,0h0l0,0h.29l0,0s0,0,0,0h0l0,0,0,0,0,0a.08.08,0,0,0,0,0s0,0,0,0v.12h0l-.49,2.78h.07A.31.31,0,0,1,437.9,282.44Zm-1.14-.38.3-1.7-1.67,1.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 285.81,
    width: 11.51,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 287.76,
    width: 17.92,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 289.7,
    width: 8.16,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 291.64,
    width: 14.64,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 293.59,
    width: 12.96,
    height: 0.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.88,
    y: 273.98,
    width: 83.86,
    height: 25.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 277.14,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 277.14,
    width: 38.32,
    height: 2.16,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 281.28,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 281.28,
    width: 68.75,
    height: 2.16,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 285.42,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 285.42,
    width: 22.18,
    height: 2.16,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 289.56,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 289.56,
    width: 58.9,
    height: 2.16,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 293.69,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 293.69,
    width: 43.31,
    height: 2.16,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.76,
    y: 311.11,
    width: 115.85,
    height: 68.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,367.93l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,373.22l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,361.85l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,355.77l47.67-.13c15.9.05,31.79,0,47.68.13-15.89.11-31.78.08-47.68.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,349.69l47.67-.13c15.9.05,31.79,0,47.68.13-15.89.1-31.78.08-47.68.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,343.6l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.09-47.68.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,337.52l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,331.44l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,325.36l47.67-.13c15.9,0,31.79,0,47.68.13-15.89.11-31.78.08-47.68.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,319.28l47.67-.13c15.9.05,31.79,0,47.68.13-15.89.11-31.78.08-47.68.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.3 365.12 234.04 351.98 239.26 354.57 253.02 341.39 256.81 344.32 265.66 339.02 277.92 347.47 280.64 344.54 287.64 350.63 298.63 341.99 305.16 347.25 312.36 345.22 312.36 373.51 221.3 373.51 221.3 365.12",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.3 365.19 233.49 362.58 244.95 351.98 249.62 354.9 258.87 346.19 266.25 349.05 269.49 346.5 278.55 355.69 291.32 341.99 301.28 351.98 312.36 346.87 312.36 373.51 221.3 373.51 221.3 365.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.58 364.86 237.13 356.45 245.51 360.01 250.09 358.55 255 361.41 267.29 354.5 269.49 357.5 273.76 356.3 282.26 360.01 293.85 355.1 300.81 360.01 312.36 351.65 312.36 373.51 221.58 373.51 221.58 364.86",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.28,
    y: 316.43,
    width: 1.3,
    height: 57.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.7,
    y: 327.18,
    width: 1.23,
    height: 92.08,
    transform: "translate(639.54 106.91) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.6,
    y: 311.11,
    width: 116.57,
    height: 68.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.84,
    y: 366.49,
    width: 4.9,
    height: 4.85,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.14,
    y: 366.49,
    width: 53.61,
    height: 1.43,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.14,
    y: 369.91,
    width: 34.64,
    height: 1.43,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,323.7c15.46-.08,30.92-.06,46.38-.09s30.91,0,46.37.09c-15.46.08-30.91.06-46.37.09S361,323.78,345.51,323.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,331.05C361,331,376.43,331,391.89,331s30.91,0,46.37.09c-15.46.07-30.91.05-46.37.09S361,331.12,345.51,331.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,338.39c15.46-.07,30.92-.05,46.38-.09s30.91,0,46.37.09c-15.46.08-30.91.06-46.37.09S361,338.47,345.51,338.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,345.74c15.46-.08,30.92-.06,46.38-.09s30.91,0,46.37.09c-15.46.08-30.91.06-46.37.09S361,345.82,345.51,345.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,353.09C361,353,376.43,353,391.89,353s30.91,0,46.37.09c-15.46.07-30.91.05-46.37.09S361,353.16,345.51,353.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.18,318.92c.14,6.87.1,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.16-20.59S364.05,325.79,364.18,318.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.22,318.92c.14,6.87.1,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.16-20.59S380.09,325.79,380.22,318.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.26,318.92c.14,6.87.1,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.16-20.59S396.13,325.79,396.26,318.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.3,318.92c.14,6.87.11,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.15-20.59S412.17,325.79,412.3,318.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.34,318.92c.14,6.87.11,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.15-20.59S428.21,325.79,428.34,318.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,347.76c2.83,0,4.52-7.47,8.53-7.47s4.44,5.45,7.81,5.45,3.27-9.56,7.81-9.56,3.48,3.88,8.23,3.88,3-9,7.92-9,2.95,12.41,8.12,12.41c3.27,0,4.54-3.94,8.45-3.94,2.58,0,4.11,2,7.49,2s4.11-7.58,8.34-7.58,4.7,4.48,7.8,4.48,4.23-7.34,9.92-7.34v29.06H347.84Z",
    style: {
      fill: "#FFD700",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,348.12v-.72c.86,0,2-1.74,2.9-3,1.49-2.18,3-4.44,5.63-4.44s3.76,1.65,4.86,3.11c.86,1.15,1.76,2.33,2.95,2.33s2-2.3,2.64-4c1.1-2.75,2.23-5.59,5.17-5.59a5.38,5.38,0,0,1,4.57,2.1,4.3,4.3,0,0,0,3.66,1.78c1.83,0,2.54-2.11,3.23-4.14.82-2.4,1.66-4.87,4.69-4.87s3.77,3.11,4.59,6.42c.66,2.67,1.47,6,3.53,6,1.23,0,2.24-.82,3.31-1.69a7.74,7.74,0,0,1,5.14-2.25,8.68,8.68,0,0,1,3.61,1,9,9,0,0,0,3.87,1c1.18,0,2.24-1.8,3.1-3.25,1.26-2.13,2.57-4.33,5.25-4.33s4,1.43,5.12,2.69c.84.92,1.64,1.79,2.68,1.79s1.91-1.39,2.8-2.62c1.52-2.11,3.42-4.72,7.12-4.72v.71c-2.85,0-4.49,2.28-5.94,4.28-1.25,1.72-2.23,3.07-4,3.07s-2.78-1.06-3.81-2.18-2.11-2.3-4-2.3-3,2-4,3.84c-1.19,2-2.22,3.74-4.31,3.74a10.74,10.74,0,0,1-4.65-1.16,6.94,6.94,0,0,0-2.83-.81c-1.71,0-2.93,1-4.1,1.94s-2.45,2-4.35,2c-3.16,0-3.95-3.21-4.79-6.62-.64-2.58-1.43-5.8-3.33-5.8s-2.76,2.28-3.44,4.29c-.83,2.43-1.6,4.73-4.48,4.73a5.61,5.61,0,0,1-4.78-2.17,4.1,4.1,0,0,0-3.45-1.72c-1.93,0-3,2.79-3.93,5-1,2.54-1.81,4.54-3.88,4.54s-3-1.34-4.12-2.77-2-2.68-3.69-2.68-3.24,2.21-4.44,4C350.61,346.58,349.57,348.12,347.84,348.12Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,319.37c.11,6.79.19,13.58.2,20.37l.1,20.37-.3-.17,45.21.05,22.61,0,22.6.09-22.6.09-22.61,0-45.21,0h-.29v-.17l.09-20.37C347.65,333,347.74,326.16,347.84,319.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.83,
    y: 311.11,
    width: 83.92,
    height: 68.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,320.39l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,323.59l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,326.79l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,330l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,333.18l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,336.38l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,339.58l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,342.78l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,346l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,349.18l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,352.38l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.07-25.88.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,355.58l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,358.78l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,362l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,365.17l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: 342.78,
    width: 5.87,
    height: 26.12,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.57,
    y: 331.73,
    width: 5.87,
    height: 37.17,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.47,
    y: 339.69,
    width: 5.87,
    height: 29.21,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.37,
    y: 329.98,
    width: 5.87,
    height: 38.92,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.26,
    y: 335.2,
    width: 5.87,
    height: 33.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.58,318.14l.16,12.69.11,12.69c.08,8.46.1,16.92.11,25.38l-.38-.38,18.84,0,18.85.05,18.84.12,6,.23-6,.23-18.84.13-18.85.05-18.84,0h-.38v-.39c0-8.46,0-16.92.11-25.38l.11-12.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.57,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.47,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.37,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.26,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.25,376.87s-16.59-3.76-25.68-12.14-14.18-23.39-14.18-23.39A142.62,142.62,0,0,1,622,346.23a31.55,31.55,0,0,1,5.63,8,37.83,37.83,0,0,0,0-5.69,25.17,25.17,0,0,1,5.91,3.58C641.12,358.68,643.25,376.87,643.25,376.87Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.75,348.64c-2.26-1.57-4.56-3.08-6.81-4.66-.14-.09,0-.31.13-.22,4.28,2.55,8.49,5.28,12.57,8.14,1.42,1,2.82,2,4.2,3.09l-.29-.49c-.5-.83-1-1.65-1.55-2.47a35.75,35.75,0,0,0-3.52-4.7c-.05-.05,0-.13.08-.08,1.29,1.49,2.58,3,3.76,4.55.56.75,1.08,1.53,1.58,2.32.26.42.5.83.74,1.26.08.14.17.28.25.43,2.15,1.68,4.24,3.44,6.23,5.29q1.85,1.72,3.56,3.56c-.64-2-1.2-4-1.94-6,0-.07.08-.1.11,0,.72,2.07,1.51,4.16,2.07,6.29q1.91,2.05,3.63,4.27l-.06-.27c-.19-.78-.39-1.56-.59-2.33-.41-1.51-.85-3-1.36-4.47a25.77,25.77,0,0,0-4.45-8.41c-.05-.06,0-.14.08-.08a32.36,32.36,0,0,1,6.35,13.27c.18.7.35,1.41.51,2.12.08.38.18.76.25,1.15.5.68,1,1.36,1.46,2.06a71.71,71.71,0,0,1,7,13.77,160.53,160.53,0,0,1,5.32,16.57c0,.11-.14.15-.17,0-3.24-9.7-6.56-19.55-12.11-28.23-1.18-1.83-2.44-3.59-3.79-5.3a31.31,31.31,0,0,1-8.07-1.6,36.1,36.1,0,0,1-8.08-3.91,48.46,48.46,0,0,1-4.15-3.13.06.06,0,1,1,.07-.09,33.17,33.17,0,0,0,7.61,4.61,41,41,0,0,0,8.37,2.8c1.22.27,2.46.47,3.71.64a69.85,69.85,0,0,0-4.9-5.42c-.56-.56-1.14-1.1-1.71-1.64a39.64,39.64,0,0,0-6.13-3.51c-2.72-1.31-5.4-2.71-8.09-4.07-1.52-.78-3-1.57-4.55-2.31a.06.06,0,0,1,0-.1c2.73,1.32,5.5,2.55,8.25,3.81,2.59,1.19,5.21,2.38,7.7,3.77l.31.19c-2.24-2-4.57-3.82-6.95-5.62C618.25,351.83,616,350.2,613.75,348.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.7,357.19c1.34.59,2.72,1.11,4,1.74a44.87,44.87,0,0,1,4,2.16.05.05,0,1,1-.05.09c-1.32-.63-2.66-1.22-4-1.88s-2.67-1.4-4.05-2C614.6,357.27,614.63,357.16,614.7,357.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.14,293.26a23.72,23.72,0,0,0-5,13.78c0,1.49.18,3.56.35,6a39.35,39.35,0,0,0-10.82,9.25,19.66,19.66,0,0,1,10.94-2.62,33.66,33.66,0,0,1-.63,5,18.81,18.81,0,0,0-7,1.39,15.75,15.75,0,0,1,6.34,1.26c-3,9.41-11.74,19.08-36,23.18a51,51,0,0,1,4.3-34.16C666.88,302,697.14,293.26,697.14,293.26Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.9,390.72q.63-6,1.57-12c1.25-8,2.86-15.94,4.9-23.76a95.63,95.63,0,0,1,3.5-10.83,18,18,0,0,1-.09-1.94c0-.78,0-1.56,0-2.33,0-1.56.09-3.11.22-4.66a54.85,54.85,0,0,1,1.5-9.1c.44-1.73,1-3.43,1.46-5.14a.06.06,0,0,1,.11,0,66.86,66.86,0,0,0-1.79,9.08,84.45,84.45,0,0,0-.82,9.11c0,.84,0,1.67,0,2.51,0,.35,0,.71,0,1.07a80.41,80.41,0,0,1,4.09-8.47,103.48,103.48,0,0,1,8.31-12.43,5.26,5.26,0,0,1,.2-1.36c.12-.54.23-1.08.35-1.62.25-1.11.53-2.21.83-3.31.61-2.2,1.4-4.32,2.09-6.49a.06.06,0,0,1,.11,0c-.64,2.15-1.07,4.38-1.56,6.56l-.72,3.25c-.12.54-.23,1.09-.35,1.63a.5.5,0,0,1,0,.12q1.47-1.86,3-3.66c4.63-5.43,9.71-10.45,14.83-15.43.63-.61,1.27-1.21,1.91-1.81,0-.05.13,0,.08.08-4.89,5.1-9.7,10.26-14.26,15.66q-1.62,1.92-3.2,3.9c.55-.38,1.11-.74,1.66-1.1,1.41-.93,2.84-1.82,4.31-2.65s3-1.63,4.47-2.38,3.22-1.4,4.73-2.27c.06,0,.12.07.05.1a34.81,34.81,0,0,0-4.43,2.45q-2.22,1.31-4.4,2.68c-1.43.9-2.86,1.79-4.28,2.72-1.18.76-2.34,1.6-3.57,2.31a113.39,113.39,0,0,0-7.77,11.32,81.54,81.54,0,0,0-4,7.62l.87-.38,2.22-1c1.43-.64,2.86-1.26,4.29-1.88,2.73-1.18,5.49-2.27,8.16-3.57a37.8,37.8,0,0,0,4.36-2.42c.06,0,.11.06.05.1-5,3.43-10.55,5.85-16.06,8.28l-2.39,1.06c-.66.29-1.31.62-2,.87a83.47,83.47,0,0,0-4.1,11.25A229.57,229.57,0,0,0,650,376c-1.39,7.93-2.33,15.91-3.06,23.92-.09,1-.18,2-.29,3,0,.4-.64.4-.63,0C646.06,398.84,646.48,394.76,646.9,390.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.67,323.69c.44-2.47,1.1-4.88,1.77-7.3a.05.05,0,1,1,.1,0c-.61,2.37-1,4.79-1.49,7.2s-.86,4.92-1.21,7.39a0,0,0,1,1-.06,0A64.25,64.25,0,0,1,661.67,323.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.13,330.38a42,42,0,0,1,5.28-3c.88-.46,1.78-.89,2.68-1.33s1.88-.82,2.8-1.28c.06,0,.12.07.05.1-.89.44-1.73,1-2.6,1.46s-1.79,1-2.7,1.47c-1.77,1-3.52,2-5.38,2.79A.14.14,0,0,1,672.13,330.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643,348.13s-15.35-3.67-22.4-14c-6.73-9.83-8.91-26.59-9.08-28.07.27,1.35,3.44,16,13.89,22.83C633.36,334.15,641.1,338.45,643,348.13Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.78,321.61a19.6,19.6,0,0,1,5.66,9.32,0,0,0,1,1-.05,0,23,23,0,0,0-5.69-9.25C628.65,321.64,628.73,321.56,628.78,321.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643,348.13s-15.35-3.67-22.4-14c-6.73-9.83-8.91-26.59-9.08-28.07a.42.42,0,0,1,0-.1s7.36,10.46,15.1,13.13S645.17,331,643,348.13Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.17,311.76a62.85,62.85,0,0,0,4.75,8.12,32.34,32.34,0,0,0,6.31,6.49c2.09,1.66,4.29,3.16,6.4,4.78l0-.07c-.39-.59-.82-1.16-1.25-1.72-.88-1.12-1.84-2.18-2.81-3.23-1.91-2.07-3.85-4.1-5.56-6.34a23.52,23.52,0,0,1-2.47-4c0-.06.08-.1.11,0,2.49,5.18,7.46,8.5,11,12.89a21,21,0,0,1,1.42,1.94,7.66,7.66,0,0,1,.88,1.56,32,32,0,0,1,5.24,5.29,22.81,22.81,0,0,0-.61-3,15.49,15.49,0,0,0-1.63-3.89c0-.06.06-.12.09-.06a18,18,0,0,1,1.79,3.86,13.5,13.5,0,0,1,.56,3.32h0a28.86,28.86,0,0,1,2.07,3.22c-.06-.33-.12-.65-.19-1-.3-1.53-.64-3.06-1-4.56a27.19,27.19,0,0,0-3.69-8.65.06.06,0,0,1,.1-.07,33.14,33.14,0,0,1,4.09,8.47c.49,1.5.88,3,1.22,4.58.17.75.32,1.51.47,2.27.07.4.16.8.22,1.2a55.07,55.07,0,0,1,3.54,10.41A153.31,153.31,0,0,1,648.43,373a161.22,161.22,0,0,1,1.05,20.61c0,.86-.06,1.72-.11,2.59,0,.22-.34.25-.35,0-.15-3.41-.24-6.82-.44-10.22s-.5-6.81-.87-10.2a179.89,179.89,0,0,0-3.2-19.85c-1.24-5.61-2.85-11.26-5.92-16.18a30.63,30.63,0,0,0-5.54-6.58c-2.15-1.93-4.51-3.63-6.78-5.42a37.33,37.33,0,0,1-6.21-6,48.8,48.8,0,0,1-4.88-7.93c-.37-.69-.74-1.38-1.1-2.08C614,311.76,614.14,311.7,614.17,311.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.82,314a51.28,51.28,0,0,0,3.42,6,0,0,0,0,1-.07.05,42,42,0,0,1-3.46-6C616.68,314,616.79,314,616.82,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.28,341.34s.24,21.82-12.8,28.11-20,1.06-28.9,3.17v0c.35-.52,6.67-9.61,16.74-12.11C684.67,357.91,696.14,350.43,699.28,341.34Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.28,341.34s.24,21.82-12.8,28.11-20,1.06-28.9,3.17v0a49.79,49.79,0,0,1,14.83-4.37C680.65,367.24,696.36,361.88,699.28,341.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.72,373a22.26,22.26,0,0,1,5.19-3.51c.28-.13.57-.24.85-.36a5.24,5.24,0,0,1,.44-.5q.59-.61,1.23-1.17a18,18,0,0,1,2.62-1.89c2.16-1.27,4.53-2.16,6.74-3.34.06,0,.12.06.05.1-1.09.56-2.15,1.19-3.21,1.81s-2.09,1.18-3.1,1.83A21.93,21.93,0,0,0,665,367.9c-.23.2-.45.42-.67.64a35.36,35.36,0,0,1,4.41-1.17c2.39-.48,4.8-.82,7.19-1.33a34.62,34.62,0,0,0,3.46-.93c1.08-.88,2.16-1.74,3.19-2.69a26.61,26.61,0,0,0,3.37-3.74c0-.05.14,0,.09.06a39.82,39.82,0,0,1-5.34,5.9c.56-.21,1.11-.44,1.66-.69a26.89,26.89,0,0,0,11.12-9.24c0-.06.14,0,.09.05a30.36,30.36,0,0,1-9,8.64,27.1,27.1,0,0,1-5.68,2.69,54.87,54.87,0,0,1-7.06,1.67,49.58,49.58,0,0,0-6.91,1.64,20.91,20.91,0,0,0-5.8,3.05,27.2,27.2,0,0,0-7.82,9.69,49,49,0,0,0-4.3,15.95c0,.24-.39.24-.37,0C647.2,388.91,649.65,379.37,656.72,373Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.86,365.89a7.54,7.54,0,0,1,2.68-2.43,9.81,9.81,0,0,0,3.19-2.64c0-.06.14,0,.09.06A10.73,10.73,0,0,1,675,363.4a9.94,9.94,0,0,0-3.07,2.54C671.9,366,671.82,365.94,671.86,365.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.94 389.11 664.34 401.1 662.52 437.75 635.16 437.75 633.34 401.1 632.75 389.11 664.94 389.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.94 389.11 664.34 401.1 633.34 401.1 632.75 389.11 664.94 389.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.83,
    y: 384.1,
    width: 36.03,
    height: 11.44,
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "680.42 256.48 602.95 256.48 602.94 157.03 668.58 157.02 680.41 168.86 680.42 256.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.42,256.48l-77.47.06h-.06v-.06L602.82,157v-.12h.12l65.64,0h0l0,0,11.83,11.84,0,0v0Zm0,0-.07-87.62,0,0-11.84-11.82.05,0-65.64.05.12-.12L603,256.48l0-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 178.28 641.68 178.21 671.94 178.28 641.68 178.36 611.42 178.28",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 180.75 641.68 180.67 671.94 180.75 641.68 180.83 611.42 180.75",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 183.22 641.68 183.14 671.94 183.22 641.68 183.29 611.42 183.22",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 185.69 641.68 185.61 671.94 185.68 641.68 185.76 611.42 185.69",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 188.16 641.68 188.08 671.94 188.15 641.68 188.23 611.42 188.16",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 190.63 641.68 190.55 671.94 190.62 641.68 190.7 611.42 190.63",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 193.09 641.68 193.01 671.94 193.09 641.68 193.17 611.42 193.09",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 195.56 641.68 195.48 671.94 195.56 641.68 195.63 611.42 195.56",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 198.03 641.68 197.95 671.94 198.02 641.68 198.1 611.42 198.03",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 200.5 641.68 200.42 671.94 200.49 641.68 200.57 611.42 200.5",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 202.97 641.68 202.89 671.94 202.96 641.68 203.04 611.42 202.97",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 205.43 641.68 205.35 671.94 205.43 641.68 205.51 611.42 205.43",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 207.9 641.68 207.82 671.94 207.9 641.68 207.97 611.42 207.9",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 210.37 641.68 210.29 671.94 210.37 641.68 210.44 611.42 210.37",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 212.84 641.68 212.76 671.94 212.83 641.68 212.91 611.42 212.84",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.82,
    y: 205.36,
    width: 4.59,
    height: 10.36,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.33,
    y: 199.83,
    width: 4.59,
    height: 15.88,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.85,
    y: 193.65,
    width: 4.59,
    height: 22.07,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.36,
    y: 190.99,
    width: 4.59,
    height: 24.72,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.88,
    y: 186.25,
    width: 4.59,
    height: 29.46,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.39,
    y: 181.57,
    width: 4.59,
    height: 34.14,
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.06,176.55l.12,9.79.08,9.79c.06,6.53.07,13.06.09,19.58l-.29-.28h14.72l14.72,0,14.72.09,14.72.17-14.72.17L642.5,216l-14.72,0h-15v-.29c0-6.52,0-13.05.08-19.58l.08-9.79Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.82,
    y: 217.78,
    width: 4.59,
    height: 0.42,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.33,
    y: 217.78,
    width: 4.59,
    height: 0.42,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.85,
    y: 217.78,
    width: 4.59,
    height: 0.42,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.36,
    y: 217.78,
    width: 4.59,
    height: 0.41,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.88,
    y: 217.78,
    width: 4.59,
    height: 0.41,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.39,
    y: 217.78,
    width: 4.59,
    height: 0.41,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.34,206.66a55.64,55.64,0,0,0,6.7-.51,61.22,61.22,0,0,0,6.6-1.19,57.08,57.08,0,0,0,12.61-4.44,44.83,44.83,0,0,0,11-7.5l.62-.57.59-.59,1.17-1.2c.72-.85,1.5-1.66,2.16-2.56a47.67,47.67,0,0,0,3.76-5.57l0,0a40,40,0,0,1-8,10.84,39.24,39.24,0,0,1-5.25,4.28,44.41,44.41,0,0,1-5.84,3.43,54.71,54.71,0,0,1-12.79,4.35A55.5,55.5,0,0,1,618.34,206.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.87 185.73 664.23 185.88 663.45 182.75 660.38 183.76 660.18 183.14 663.91 181.91 664.87 185.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.13,
    y: 231.11,
    width: 63.11,
    height: 2.55,
    transform: "translate(1283.38 464.72) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.13,
    y: 237.56,
    width: 35.53,
    height: 2.55,
    transform: "translate(1255.81 477.62) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.91,
    y: 168.02,
    width: 35.53,
    height: 2.55,
    transform: "translate(1283.37 338.53) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "680.42 168.86 668.58 168.86 668.58 157.02 680.42 168.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "698.84 333.73 621.37 333.73 621.36 234.28 687 234.28 698.84 246.11 698.84 333.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.84,333.73l-77.47.06h-.06v-.06l-.07-99.45v-.12h.12l65.64,0h0l0,0,11.82,11.84,0,0v0Zm0,0-.07-87.62,0,0L687,234.33l0,0-65.64.05.12-.12-.06,99.45,0-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.33,
    y: 245.27,
    width: 35.53,
    height: 2.55,
    transform: "translate(1320.22 493.03) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "698.84 246.12 687 246.12 687 234.27 698.84 246.12",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.08,264.42a5.85,5.85,0,1,1-.77-2.92A5.87,5.87,0,0,1,645.08,264.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.31,261.5l-5.1,2.92v-5.87A5.87,5.87,0,0,1,644.31,261.5Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.27,264.42a4.06,4.06,0,1,1-4.06-4.06A4.06,4.06,0,0,1,643.27,264.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.52,
    y: 263.51,
    width: 3.38,
    height: 0.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.68,
    y: 264.84,
    width: 5.06,
    height: 0.48,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.08,279.58a6.11,6.11,0,0,1-.06.86,6,6,0,1,1,.06-.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.08,279.58a6.11,6.11,0,0,1-.06.86l-5.81-.86v-5.87a5.85,5.85,0,0,1,5.87,5.87Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.27,279.58a4.06,4.06,0,1,1-4.06-4.06A4.06,4.06,0,0,1,643.27,279.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.52,
    y: 278.68,
    width: 3.38,
    height: 0.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.68,
    y: 280,
    width: 5.06,
    height: 0.48,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,264.42a5.87,5.87,0,0,1-3.76,5.48,5.94,5.94,0,0,1-2.11.39,5.88,5.88,0,1,1,5.87-5.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,264.42a5.87,5.87,0,0,1-3.76,5.48l-2.11-5.48v-5.87a5.85,5.85,0,0,1,5.87,5.87Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.49,264.42a4.06,4.06,0,1,1-4.06-4.06A4.06,4.06,0,0,1,673.49,264.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.74,
    y: 263.51,
    width: 3.38,
    height: 0.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.91,
    y: 264.84,
    width: 5.06,
    height: 0.48,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,279.58a5.85,5.85,0,1,1-.77-2.92A5.84,5.84,0,0,1,675.3,279.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,279.58a5.87,5.87,0,0,1-9.68,4.46l3.81-4.46v-5.87a5.85,5.85,0,0,1,5.87,5.87Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.49,279.58a4.06,4.06,0,1,1-4.06-4.06A4.06,4.06,0,0,1,673.49,279.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.74,
    y: 278.68,
    width: 3.38,
    height: 0.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.9,
    y: 280,
    width: 5.06,
    height: 0.48,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 262.61,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 264.19,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 265.77,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 277.77,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 279.35,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 280.93,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 262.61,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 264.19,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 265.77,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 277.77,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 279.35,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 280.93,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,293.76c5-.1,9.92-.08,14.89-.12s9.92,0,14.89.12c-5,.11-9.93.09-14.89.13S662,293.87,657.08,293.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,296.6c5-.11,9.92-.08,14.89-.13s9.92,0,14.89.13c-5,.1-9.93.08-14.89.12S662,296.7,657.08,296.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,299.43c5-.11,9.92-.08,14.89-.13s9.92,0,14.89.13c-5,.11-9.93.08-14.89.12S662,299.54,657.08,299.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,302.26c5-.11,9.92-.08,14.89-.12s9.92,0,14.89.12c-5,.11-9.93.08-14.89.13S662,302.37,657.08,302.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,305.09C662,305,667,305,672,305s9.92,0,14.89.12c-5,.11-9.93.08-14.89.13S662,305.2,657.08,305.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,307.92c2.58-.1,5.17-.08,7.76-.12s5.17,0,7.76.12c-2.59.11-5.18.08-7.76.13S659.66,308,657.08,307.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.34,315.87c8.92-.11,17.84-.08,26.76-.12s17.84,0,26.76.12c-8.92.11-17.84.08-26.76.13S642.26,316,633.34,315.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.34,318.7c8.92-.1,17.84-.08,26.76-.12s17.84,0,26.76.12c-8.92.11-17.84.08-26.76.13S642.26,318.81,633.34,318.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.34,321.53c4.65-.1,9.3-.08,13.95-.12s9.3,0,13.94.12c-4.64.11-9.29.09-13.94.13S638,321.64,633.34,321.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.71,304.79l.2-.34-.2.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.91,304.45a6.61,6.61,0,0,0,.73-1.85A6.32,6.32,0,0,1,648.91,304.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.62,301.79a.68.68,0,0,1,0,.15.77.77,0,0,0,0-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.65,301.05c0,.11,0,.21,0,.31s0,.29,0,.43a.77.77,0,0,1,0,.15.71.71,0,0,1,0,.15v.05c0,.11,0,.22-.05.33s0,.07,0,.11,0,.28-.08.42-.05.26-.08.38,0,.12,0,.18-.05.19-.08.28a1.42,1.42,0,0,1-.07.22c-.07.22-.15.44-.24.65l-.09.22c-.06.13-.11.25-.18.37a2.1,2.1,0,0,1-.15.3c-.06.12-.13.24-.2.36l-.15.24-2.45-1.41.2-.34a6.32,6.32,0,0,0,.73-1.85,2.57,2.57,0,0,0,.08-.4,2.7,2.7,0,0,0,.06-.41c0-.14,0-.28,0-.43s0-.2,0-.3a1.69,1.69,0,0,0,0-.23,1.34,1.34,0,0,0,0-.2v-.07c0-.13,0-.26,0-.39a.63.63,0,0,0,0-.19c0-.15-.05-.3-.08-.44a5.91,5.91,0,0,0-.24-.82c0-.06,0-.13-.08-.19a1.67,1.67,0,0,0-.08-.2l-.08-.19-.07-.13c0-.09-.09-.18-.14-.27s-.13-.22-.2-.33a7.7,7.7,0,0,0-.48-.67,7.32,7.32,0,0,0-.87-.89,6.48,6.48,0,0,0-.67-.5l1.42-2.45c.21.13.41.28.61.42l.36.28h0l.35.3.3.29.05.05.29.3.07.08.24.29.29.36.26.36,0,.06.18.28.06.09.21.39a7.61,7.61,0,0,1,.4.81s0,0,0,0,.12.29.17.43l.15.42a.43.43,0,0,1,0,0c0,.12.08.24.11.37l0,.16c.07.28.12.56.17.84v0c0,.15,0,.29.05.44a.13.13,0,0,1,0,.06c0,.15,0,.3,0,.44v.06C652.65,300.75,652.65,300.9,652.65,301.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.74,295.35a6.48,6.48,0,0,1,.67.5C647.19,295.67,647,295.51,646.74,295.35Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.28,296.74a8.14,8.14,0,0,0-.87-.89A7.32,7.32,0,0,1,648.28,296.74Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.34,293l-.18-.12h0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.77,293.32l-.43-.3Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.41,298.72a5.91,5.91,0,0,1,.24.82C649.58,299.26,649.5,299,649.41,298.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.81,300.83a1.69,1.69,0,0,1,0,.23c0,.1,0,.2,0,.3h0c0-.1,0-.2,0-.31A1.62,1.62,0,0,0,649.81,300.83Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.79,292.68l-1.41,2.45a6.7,6.7,0,0,0-3.17-.89V291.4A9.62,9.62,0,0,1,647.79,292.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.66,296.18l.08-.13-.08.14Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.74,296.05a9.33,9.33,0,0,1,1.43-1.82A9.64,9.64,0,0,0,634.74,296.05Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.17,294.23a6.67,6.67,0,0,1,.68-.62C636.62,293.81,636.39,294,636.17,294.23Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.85,293.61a9.85,9.85,0,0,1,2.39-1.45A9.85,9.85,0,0,0,636.85,293.61Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.24,292.16a8.44,8.44,0,0,1,1.34-.45A10,10,0,0,0,639.24,292.16Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.78,291.4h0a9.41,9.41,0,0,0-2.2.3A9.42,9.42,0,0,1,642.78,291.4Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.78,291.41v2.83h-.14l-.31,0h0c-.23,0-.46.06-.68.1l-.33.08-.25.07-.08,0-.31.11h0l-.29.12a6.62,6.62,0,0,0-.88.45,5.25,5.25,0,0,0-.49.33.94.94,0,0,0-.12.09l-.14.1-.24.2s0,0,0,0a3.45,3.45,0,0,0-.28.26l0,0-.25.27,0,0c-.08.1-.17.2-.24.3s-.17.23-.25.35h0c-.08.12-.16.24-.23.36l-.2.37,0,0c0,.09-.09.19-.13.29l0,0-.09.2a1.34,1.34,0,0,1-.07.18c0,.1-.07.21-.1.32s-.07.23-.1.35,0,.2-.07.3,0,.17,0,.26,0,.09,0,.14,0,.1,0,.15a1.79,1.79,0,0,0,0,.23.86.86,0,0,0,0,.16,3,3,0,0,0,0,.31h-2.83a9.52,9.52,0,0,1,1.12-4.38c.06-.13.13-.25.2-.37l.08-.14a9.64,9.64,0,0,1,1.43-1.82c.22-.22.45-.42.68-.62a9.85,9.85,0,0,1,2.39-1.45,10,10,0,0,1,1.34-.45h0A9.41,9.41,0,0,1,642.78,291.41Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.45,296.56h0a9.52,9.52,0,0,0-1.12,4.38h0A9.61,9.61,0,0,1,634.45,296.56Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.19,306.72l-1.42,2.46a9.64,9.64,0,0,1-4.43-7.82h2.84A6.81,6.81,0,0,0,639.19,306.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.92,306.56a9.62,9.62,0,0,1-7.93,4.15,9.49,9.49,0,0,1-4.85-1.31l1.42-2.45a6.82,6.82,0,0,0,8.9-1.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.52,301.14l-1.23,1h1.23a.09.09,0,0,1,.1.09.1.1,0,0,1-.1.1H638a.12.12,0,0,1-.08,0,.09.09,0,0,1,0-.13l1.45-1.13a.83.83,0,0,0,.33-.64.53.53,0,0,0-.56-.55.79.79,0,0,0-.5.18l-.15.12a.09.09,0,0,1-.13,0,.09.09,0,0,1,0-.13l.15-.12a1,1,0,0,1,.62-.22.75.75,0,0,1,.61.29.73.73,0,0,1,.14.45A1.05,1.05,0,0,1,639.52,301.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642,299.92a1.21,1.21,0,0,1,.19.71,2,2,0,0,1,0,.34l-.09,0,.09,0a2,2,0,0,1-.42.92,1,1,0,0,1-.72.4h0a.66.66,0,0,1-.54-.31,1.29,1.29,0,0,1-.19-.71,1.84,1.84,0,0,1,0-.33,2,2,0,0,1,.42-.93,1,1,0,0,1,.72-.4A.66.66,0,0,1,642,299.92Zm0,.71a1.1,1.1,0,0,0-.16-.61.47.47,0,0,0-.39-.22.82.82,0,0,0-.58.33,1.81,1.81,0,0,0-.38.84,1.51,1.51,0,0,0,0,.3,1.1,1.1,0,0,0,.16.61.45.45,0,0,0,.39.22.82.82,0,0,0,.58-.33,1.82,1.82,0,0,0,.38-.83A1.67,1.67,0,0,0,642,300.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.68,299.92a1.21,1.21,0,0,1,.19.71,2,2,0,0,1,0,.34l-.09,0,.09,0a1.86,1.86,0,0,1-.42.92,1,1,0,0,1-.72.4h0a.63.63,0,0,1-.54-.31,1.22,1.22,0,0,1-.2-.71c0-.11,0-.22,0-.33a2,2,0,0,1,.43-.93,1,1,0,0,1,.72-.4A.63.63,0,0,1,644.68,299.92Zm0,.71a1.1,1.1,0,0,0-.16-.61.47.47,0,0,0-.39-.22.82.82,0,0,0-.58.33,1.81,1.81,0,0,0-.38.84,1.53,1.53,0,0,0,0,.3,1.1,1.1,0,0,0,.16.61.45.45,0,0,0,.39.22.82.82,0,0,0,.58-.33,1.82,1.82,0,0,0,.38-.83A1.71,1.71,0,0,0,644.69,300.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.46,299.72l-.27,1.53,1.9-1.62a.09.09,0,1,1,.12.14l-1.22,1,.86,1.33a.09.09,0,0,1,0,.13h-.05a.09.09,0,0,1-.08,0l-.85-1.31-.71.6h0l-.12.68a.1.1,0,0,1-.09.07h0a.09.09,0,0,1-.07-.11l.43-2.48a.09.09,0,0,1,.11-.08A.1.1,0,0,1,646.46,299.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.22,152h-.75v-.91h.75Zm0-2.91h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm-2.1-1.91h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.35 151.6 645.85 154.19 647.34 151.6 644.35 151.6",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.41,301.84h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-1.49h1.26v.75h-.51Zm40.51-.74h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.22 178.22 152.81 176.73 150.22 175.23 150.22 178.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.14 260.19 77.03 260.19 84.84 215.9 145.94 215.9 138.14 260.19",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.24 211.32 85.65 211.32 84.84 215.9 107.67 215.9 107.24 211.32",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "138.14 260.19 77.03 260.19 84.84 215.9 145.94 215.9 138.14 260.19"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "107.24 211.32 85.65 211.32 84.84 215.9 107.67 215.9 107.24 211.32"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "104.72 215.37 87.06 215.37 87.53 212.7 105.19 212.7 104.72 215.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.25,
    y: 212.83,
    width: 56.84,
    height: 44.28,
    transform: "translate(-11.26 5.49) rotate(-2.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.26 253.03 91.38 235.76 90.58 218.49 91.47 235.76 92.26 253.03",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.67 252.97 92.79 235.69 91.99 218.42 92.87 235.69 93.67 252.97",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.08 252.9 94.19 235.63 93.4 218.35 94.28 235.62 95.08 252.9",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.49 252.83 95.6 235.56 94.81 218.28 95.69 235.55 96.49 252.83",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.89 252.76 97.01 235.49 96.22 218.21 97.1 235.49 97.89 252.76",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.3 252.69 98.42 235.42 97.63 218.14 98.51 235.42 99.3 252.69",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.71 252.63 99.83 235.35 99.04 218.07 99.92 235.35 100.71 252.63",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.12 252.56 101.24 235.28 100.44 218.01 101.33 235.28 102.12 252.56",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.53 252.49 102.65 235.22 101.85 217.94 102.74 235.21 103.53 252.49",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.94 252.42 104.06 235.15 103.26 217.87 104.14 235.14 104.94 252.42",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.35 252.35 105.47 235.08 104.67 217.8 105.55 235.07 106.35 252.35",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.76 252.28 106.88 235.01 106.08 217.73 106.96 235.01 107.76 252.28",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.17 252.22 108.28 234.94 107.49 217.66 108.37 234.94 109.17 252.22",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.57 252.15 109.69 234.87 108.9 217.6 109.78 234.87 110.57 252.15",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.98 252.08 111.1 234.81 110.31 217.53 111.19 234.8 111.98 252.08",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.12,
    y: 244.22,
    width: 2.62,
    height: 5.92,
    transform: "translate(-131.11 369.45) rotate(-92.78)",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.3,
    y: 237.86,
    width: 2.62,
    height: 9.08,
    transform: "translate(-128.23 362.63) rotate(-92.78)",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.3,
    y: 231.31,
    width: 2.62,
    height: 12.61,
    transform: "translate(-125.56 355.63) rotate(-92.78)",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.31,
    y: 225.73,
    width: 2.62,
    height: 14.13,
    transform: "matrix(-0.05, -1, 1, -0.05, -121.78, 349.58)",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.72,
    y: 219.58,
    width: 2.62,
    height: 16.84,
    transform: "translate(-118.66 342.95) rotate(-92.78)",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.15,
    y: 213.45,
    width: 2.62,
    height: 19.51,
    transform: "translate(-115.52 336.35) rotate(-92.78)",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.22,252.15l5.59-.34,5.59-.32c3.72-.21,7.45-.4,11.17-.59l-.15.17-.42-8.4-.38-8.41-.36-8.4-.31-8.41.5,8.4.46,8.4.43,8.4.4,8.4v.17h-.16c-3.73.18-7.45.35-11.18.5l-5.59.22Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.37,
    y: 246.85,
    width: 2.62,
    height: 0.24,
    transform: "translate(-126.44 373.5) rotate(-92.78)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.14,
    y: 241.99,
    width: 2.62,
    height: 0.24,
    transform: "matrix(-0.05, -1, 1, -0.05, -121.83, 368.17)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.9,
    y: 237.13,
    width: 2.62,
    height: 0.24,
    transform: "translate(-117.23 362.83) rotate(-92.78)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.67,
    y: 232.27,
    width: 2.62,
    height: 0.24,
    transform: "translate(-112.62 357.49) rotate(-92.78)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.43,
    y: 227.41,
    width: 2.62,
    height: 0.24,
    transform: "translate(-108.01 352.16) rotate(-92.78)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.19,
    y: 222.55,
    width: 2.62,
    height: 0.24,
    transform: "translate(-103.4 346.83) rotate(-92.78)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27,248.3a32.51,32.51,0,0,0-.48-3.81,36.82,36.82,0,0,0-.86-3.74,32.73,32.73,0,0,0-2.89-7.07,25.74,25.74,0,0,0-4.58-6.09l-.34-.34-.36-.31-.71-.64c-.51-.39-1-.81-1.53-1.16a27.27,27.27,0,0,0-3.28-2v0a22.87,22.87,0,0,1,6.41,4.25,22.1,22.1,0,0,1,2.59,2.88,25.78,25.78,0,0,1,2.12,3.24,30.84,30.84,0,0,1,2.83,7.18A31.69,31.69,0,0,1,108.27,248.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.03 222.32 95.14 222.68 93.37 223.21 94.03 224.93 93.68 225.07 92.88 222.97 95.03 222.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.27,
    y: 233.53,
    width: 36.07,
    height: 1.46,
    transform: "translate(350.37 100.75) rotate(87.22)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.21,
    y: 241.23,
    width: 20.31,
    height: 1.46,
    transform: "translate(361.92 104.01) rotate(87.22)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.14,
    y: 235.28,
    width: 20.31,
    height: 1.46,
    transform: "translate(317.84 138.38) rotate(87.22)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.25 260.19 77.15 260.19 65.27 219.58 126.38 219.58 138.25 260.19",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.63 215.37 64.04 215.37 65.27 219.58 88.1 219.58 85.63 215.37",
    style: {
      fill: "#FFD700"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.48,
    y: 218.55,
    width: 13.24,
    height: 52.09,
    transform: "translate(1019.73 97.78) rotate(138)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.86 303.73 545.74 290.33 545.74 290.33 509.64 250.23 509.64 250.23 494.76 263.63 494.76 263.63 530.86 303.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,192.46l-.06.3-.09.46c-.11.57-.22,1.13-.35,1.67,0,.18-.08.35-.13.52a49.64,49.64,0,0,1-2.61,7.92c-.08.2-.16.4-.25.59a50.93,50.93,0,0,1-4.94,8.82l-.24.34a51.76,51.76,0,0,1-16.16,14.75l-.42.25A52.26,52.26,0,0,1,449.5,233l-1.56.41a50.76,50.76,0,0,1-15.32,1.34l-.36,0a52.32,52.32,0,0,1-6.39-.85c-.68-.13-1.36-.28-2-.45s-1.19-.3-1.78-.46A51.08,51.08,0,0,1,407,226.06c-.24-.16-.5-.33-.74-.51-.94-.65-1.85-1.34-2.74-2.06l-.46-.38a51.15,51.15,0,0,1-9.24-9.94l-.37-.52c-.16-.22-.31-.45-.46-.67a52.16,52.16,0,0,1-6.12-12.42c-.11-.32-.21-.64-.31-1a53.39,53.39,0,0,1-1.45-5.73c0-.18-.06-.35-.1-.53a51.74,51.74,0,0,1,.19-19.09l.14-.68.12-.53a51.18,51.18,0,0,1,12.41-23.77,52.64,52.64,0,0,1,9.25-7.9Q409,139.11,411,138a51.68,51.68,0,0,1,75.3,34.12,1.59,1.59,0,0,1,.06.3A51.2,51.2,0,0,1,486.63,192.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,192.46l-.06.3-.09.46c-.11.57-.22,1.13-.35,1.67,0,.18-.08.35-.13.52a49.64,49.64,0,0,1-2.61,7.92c-.08.2-.16.4-.25.59a50.93,50.93,0,0,1-4.94,8.82l-.24.34a51.76,51.76,0,0,1-16.16,14.75l-.42.25A52.26,52.26,0,0,1,449.5,233l-1.56.41a50.76,50.76,0,0,1-15.32,1.34l-.36,0a52.32,52.32,0,0,1-6.39-.85c-.68-.13-1.36-.28-2-.45s-1.19-.3-1.78-.46A51.08,51.08,0,0,1,407,226.06c-.24-.16-.5-.33-.74-.51-.94-.65-1.85-1.34-2.74-2.06l-.46-.38a51.15,51.15,0,0,1-9.24-9.94l-.37-.52c-.16-.22-.31-.45-.46-.67a52.16,52.16,0,0,1-6.12-12.42c-.11-.32-.21-.64-.31-1a53.39,53.39,0,0,1-1.45-5.73c0-.18-.06-.35-.1-.53a51.74,51.74,0,0,1,.19-19.09l.14-.68.12-.53a51.18,51.18,0,0,1,12.41-23.77,52.64,52.64,0,0,1,9.25-7.9Q409,139.11,411,138a51.68,51.68,0,0,1,75.3,34.12,1.59,1.59,0,0,1,.06.3A51.2,51.2,0,0,1,486.63,192.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,192.46l-.06.3-.09.46c-.11.57-.22,1.13-.35,1.67,0,.18-.08.35-.13.52a49.64,49.64,0,0,1-2.61,7.92c-.08.2-.16.4-.25.59a50.93,50.93,0,0,1-4.94,8.82l-.24.34a51.76,51.76,0,0,1-16.16,14.75l-.42.25A52.26,52.26,0,0,1,449.5,233l-1.56.41a50.76,50.76,0,0,1-15.32,1.34l-.36,0a52.32,52.32,0,0,1-6.39-.85c-.68-.13-1.36-.28-2-.45s-1.19-.3-1.78-.46A51.08,51.08,0,0,1,407,226.06c-.24-.16-.5-.33-.74-.51-.94-.65-1.85-1.34-2.74-2.06l-.46-.38a51.15,51.15,0,0,1-9.24-9.94l-.37-.52c-.16-.22-.31-.45-.46-.67a52.16,52.16,0,0,1-6.12-12.42c-.11-.32-.21-.64-.31-1a53.39,53.39,0,0,1-1.45-5.73c0-.18-.06-.35-.1-.53a51.74,51.74,0,0,1,.19-19.09l.14-.68.12-.53a51.18,51.18,0,0,1,12.41-23.77,52.64,52.64,0,0,1,9.25-7.9Q409,139.11,411,138H460.8a50.8,50.8,0,0,1,13,10.24,52.14,52.14,0,0,1,12.47,23.88,1.59,1.59,0,0,1,.06.3A51.2,51.2,0,0,1,486.63,192.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.8,148.27H397.87a52.64,52.64,0,0,1,9.25-7.9Q409,139.11,411,138H460.8A50.8,50.8,0,0,1,473.8,148.27Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.56,213.16v1l0,9.29-.46-.38,0-8.91v-1.55l.05-11.85v-8.45l0-9.57.13-10.22.14,10.22,0,9.57v8.45l.05,11.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.71,214.2,432.63,233v1.77l-.36,0V233l-.09-18.79v-1.51l0-5.73v-5.9l0-2.69v-6l0-9.61.14-10.26.13,10.26.05,9.61v6l0,2.69V207l0,5.73v1.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.85,213.1v1.1l-.05,13.63-.42.25-.06-13.88V203.48l0-8V189.5l0-6.72.13-10.29.13,10.29,0,6.72v5.93l0,8v9.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.33,172.45l-14.29,0H461.59l-29.15,0-29.16,0H385.34l.12-.53,86.58.08,14.23,0A1.59,1.59,0,0,1,486.33,172.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,192.46l-.06.3-14.53,0H458.63l-24.73,0H431l-27.5,0H385.11c0-.18-.06-.35-.1-.53h18.45l28.8,0h.36l26,0H472Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.2,212.74l-.24.34H461.32l-28.62,0h-.53l-14.24,0H393.82l-.37-.52h10.1l13.66,0h1.13l13.83,0h.53l28.62,0H478.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.5,233l-1.56.41h-24.1c-.6-.14-1.19-.3-1.78-.46h10.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.13,194.89c0,.18-.08.35-.13.52l-21.55-2.19-.54-.05-.55-.06-1.59-.16h-.13l-.23.09-1.37.52-.52.2-.51.2-14.48,5.59-1,.39-8.22,3.17-.51.2-.51.2-1.59.6-.08,0-.11,0-.11,0-.15,0-1.64-.34-.54-.1-.53-.11-3-.6-.91-.19-19.54-4-.54-.1-.54-.12-1.52-.31-.22,0-.18,0-1.61.14-.55,0-.54,0-13.52,1.08c-.11-.32-.21-.64-.31-1l13.78-1,.54-.05.55,0,1.66-.13h.29l.11,0,1.68.36.55.1.53.11,20,4.16.9.18,2.59.54.55.11.55.12,1.38.28.2.05.25-.11,1.23-.46.53-.21.51-.18,7.51-2.86,1.05-.4,15.26-5.81.51-.2.5-.19.38-.15,1-.38.26-.1.06,0,.07,0h.08l.15,0,1.18.12.53.06.53.05.53.06,1.91.21Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.87,204a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,434.87,204Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.27,203.1a3.4,3.4,0,0,0-.34-.69,2.91,2.91,0,0,0-2.28-1.35h-.43a2.92,2.92,0,0,0-2.49,1.75,2.54,2.54,0,0,0-.23.77,2.12,2.12,0,0,0,0,.44,3,3,0,0,0,2.73,2.94,1,1,0,0,0,.25,0,.93.93,0,0,0,.24,0,3,3,0,0,0,2.73-2.94A3.16,3.16,0,0,0,435.27,203.1Zm-2.6,2.79-.23,0-.24,0a1.89,1.89,0,0,1-1.65-1.87,2.08,2.08,0,0,1,.28-1,1.89,1.89,0,0,1,1.39-.91h.43a1.91,1.91,0,0,1,1.24.67,1.87,1.87,0,0,1,.36.7,1.81,1.81,0,0,1,.07.52A1.88,1.88,0,0,1,432.67,205.89Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.72,197.84a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,405.72,197.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.48,194.87h-.38a3,3,0,0,0-2.76,2.69,1.27,1.27,0,0,0,0,.28,3.39,3.39,0,0,0,.07.64,3,3,0,0,0,2.69,2.32h.42a3,3,0,0,0,2.59-2,2.65,2.65,0,0,0,.16-.89.28.28,0,0,0,0-.09A3,3,0,0,0,403.48,194.87Zm1.7,3a1.76,1.76,0,0,1-.17.76,1.89,1.89,0,0,1-1.51,1.12h-.42a1.91,1.91,0,0,1-1.6-1.32,2,2,0,0,1-.08-.56,2.31,2.31,0,0,1,0-.37A1.91,1.91,0,0,1,403.1,196h.38a1.87,1.87,0,0,1,1.69,1.76A.45.45,0,0,1,405.18,197.84Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,192.47a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,464,192.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.75,189.5h-.32a3,3,0,0,0-2.81,2.92v.05c0,.11,0,.22,0,.33a2.36,2.36,0,0,0,.12.54,2.73,2.73,0,0,0,.26.61,3,3,0,0,0,2.39,1.48h.38a3,3,0,0,0,2.67-2.21,2,2,0,0,0,.08-.42,1.41,1.41,0,0,0,0-.21.49.49,0,0,0,0-.12v-.05A3,3,0,0,0,461.75,189.5Zm1.73,3a1.73,1.73,0,0,1,0,.32,1.4,1.4,0,0,1-.09.31,1.9,1.9,0,0,1-1.59,1.24h-.37a1.89,1.89,0,0,1-1.36-.8,1.65,1.65,0,0,1-.28-.6.66.66,0,0,1,0-.15,1.84,1.84,0,0,1,0-.33v-.05a1.89,1.89,0,0,1,1.73-1.83h.34a1.9,1.9,0,0,1,1.72,1.83Z",
    style: {
      fill: "#FFD700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39,203.33c-.08.2-.16.4-.25.59l-18.6,2.36-.53.06-.53.07-1.66.2-.19,0h-.08l-.07,0-.13,0-1.6-.6-.5-.19-.51-.18-15.25-5.68-1.05-.38-7.38-2.75-.51-.19-.52-.2-1.4-.52-.07,0-.31.37-.7.82h0l-.35.43-.35.41-3.7,4.37-.6.71-8.2,9.69-.41.48L407,226.06c-.24-.16-.5-.33-.74-.51l10.56-12.4.39-.48,8.42-9.88.61-.7,4-4.7.35-.42.37-.42,1.18-1.4.12-.13.06-.08.27.1h.05l1.68.64.51.19.51.19,8.16,3.08,1,.39L459,205l.51.19.52.2,1.32.5.28.1.19,0,1.52-.17.55-.07.55-.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.87,195.41a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,434.87,195.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.9,192.83a2.9,2.9,0,0,0-1.28-.38h-.36a3,3,0,0,0-2,4.94,2.67,2.67,0,0,0,.61.51,2.75,2.75,0,0,0,1.4.47h.39a3,3,0,0,0,2.43-1.57,2.67,2.67,0,0,0,.27-.73,2.93,2.93,0,0,0-1.43-3.24Zm.41,2.86a1.81,1.81,0,0,1-.28.72,1.88,1.88,0,0,1-1.4.88h-.39a1.66,1.66,0,0,1-.69-.23h0a1.53,1.53,0,0,1-.59-.51,1.82,1.82,0,0,1-.4-1.15,1.89,1.89,0,0,1,1.71-1.87h.36a1.88,1.88,0,0,1,1.7,1.87C434.32,195.5,434.31,195.59,434.31,195.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,206.45a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,464,206.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.54,206.28a2.67,2.67,0,0,0-.1-.64,3,3,0,0,0-2.63-2.16h-.45A3,3,0,0,0,459,205a2.62,2.62,0,0,0-.26.62,2.55,2.55,0,0,0-.12.84,3,3,0,0,0,2.71,3,1.14,1.14,0,0,0,.26,0,1,1,0,0,0,.24,0,3,3,0,0,0,2.72-3A.91.91,0,0,0,464.54,206.28Zm-1.06.17a1.87,1.87,0,0,1-1.66,1.86l-.23,0-.25,0a1.87,1.87,0,0,1-1.65-1.86,1.73,1.73,0,0,1,.06-.47,1.93,1.93,0,0,1,.28-.6,1.8,1.8,0,0,1,1.33-.8.9.9,0,0,1,.23,0,.93.93,0,0,1,.23,0,1.83,1.83,0,0,1,1.52,1.2,1.62,1.62,0,0,1,.14.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,242.43A60.34,60.34,0,1,1,495,194.91,60.4,60.4,0,0,1,424.17,242.43Zm1.34-6.79a53.41,53.41,0,1,0-42.07-62.74A53.46,53.46,0,0,0,425.51,235.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.48,170.06a55.58,55.58,0,0,0-7.79-17.56A55.19,55.19,0,1,0,390,214a55.18,55.18,0,0,0,100-20.06A54.77,54.77,0,0,0,489.48,170.06Zm-3,23.16a51.68,51.68,0,1,1-7.79-38.72A51.69,51.69,0,0,1,486.49,193.22Zm3-23.16a55.58,55.58,0,0,0-7.79-17.56A55.19,55.19,0,1,0,390,214a55.18,55.18,0,0,0,100-20.06A54.77,54.77,0,0,0,489.48,170.06Zm-3,23.16a51.68,51.68,0,1,1-7.79-38.72A51.69,51.69,0,0,1,486.49,193.22Zm9.7-24.81a62.1,62.1,0,1,0,.61,26.84A62,62,0,0,0,496.19,168.41Zm-2.91,26.15a58.56,58.56,0,1,1-.59-25.29A58.22,58.22,0,0,1,493.28,194.56ZM481.69,152.5A55.19,55.19,0,1,0,390,214a55.18,55.18,0,0,0,100-20.06,54.77,54.77,0,0,0-.53-23.85A55.58,55.58,0,0,0,481.69,152.5Zm4.8,40.72a51.68,51.68,0,1,1-7.79-38.72A51.69,51.69,0,0,1,486.49,193.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.72,154.49a51.66,51.66,0,1,1-32.89-21.88A51.68,51.68,0,0,1,478.72,154.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.38,147a39.45,39.45,0,0,1,15.42-5.62,41.28,41.28,0,0,1,8.4-.45,43.81,43.81,0,0,1,8.42,1.26,41.15,41.15,0,0,1,15.22,7.64,45.6,45.6,0,0,1,11,12.71A81.81,81.81,0,0,0,461.27,152a50.1,50.1,0,0,0-7-3.82,41.46,41.46,0,0,0-7.45-2.62,50.56,50.56,0,0,0-15.66-1.5A66.47,66.47,0,0,0,415.38,147Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataExtractionBro);
export default __webpack_public_path__ + "static/media/Data-extraction-bro.d91034cec42b2194e3f87a2822dfe022.svg";
export { ForwardRef as ReactComponent };